// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-09-14T13:29:56.174Z
// Property: Echo Biltmore (ID: 6767906449166424)
// Collections: 22 amenities, 23 floorplans (live), 26 photos, 73 POIs, 5 reviews, 8 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5742705921490944",
  "multihub_property_id": "6767906449166424",
  "property_external_id": "2zp4mrc",
  "property_zillow_url": "https://www.zillow.com/apartments/phoenix-az/alta-biltmore/CkB94F/",
  "property_apartments_url": "https://www.apartments.com/alta-biltmore-phoenix-az/2zp4mrc/",
  "property_google_business_url": "https://www.google.com/maps/place/Echo+Biltmore/data=!4m2!3m1!1s0x0:0x6e96cc330d31446c?sa=X&ved=2ahUKEwiewODk4KeSAxVkR2wGHX0GEL8Q_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "40249517126",
  "property_crm_software": "Anyone Home",
  "property_pm_software": "AIM",
  "property_pm_info": "1109ECHO",
  "property_status": null,
  "property_slug": "echo-biltmore",
  "property_name": "Echo Biltmore",
  "property_website_url": "https://www.echobiltmore.com/",
  "property_domain": "https://www.echobiltmore.com/",
  "property_address": "1720 East Camelback Road",
  "property_full_address": "1720 E Camelback Rd, Phoenix, AZ 85016",
  "property_address_1": "1720 E Camelback Rd",
  "property_address_2": null,
  "property_address_city": "Phoenix",
  "property_address_state": "AZ",
  "property_address_zip_full": null,
  "property_address_zip": "85016",
  "property_address_country": "US",
  "property_address_county": "Maricopa County",
  "property_neighborhood_address": "Camelback East Village",
  "property_address_latitude": "33.5101761",
  "property_address_longitude": "-112.0448986",
  "property_email": null,
  "property_phone": "(484) 235-5942",
  "property_call_tracking_phone": "(888) 520-6389",
  "property_company_name": "Apartment Management Consultants",
  "property_company_url": "https://www.liveamc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Echo Biltmore, where luxury meets convenience in the heart of Phoenix, AZ. Choose from spacious one and two-bedroom floor plans that blend modern finishes with comfort. Enjoy resort-style amenities including a pool, fitness center, and a clubhouse. Embrace a lifestyle of leisure and connectivity—your new home awaits!",
  "property_long_description": "**Welcome to Echo Biltmore: Your Ideal Apartment Community in Phoenix, AZ**\n\nDiscover the perfect blend of comfort and luxury at Echo Biltmore, where modern living meets exceptional amenities. Our thoughtfully designed one-bedroom and two-bedroom apartments offer spacious layouts that fit your lifestyle. Each unit features high ceilings, hardwood floors, and stunning quartz countertops, complemented by stainless steel appliances, spacious walk-in closets, and convenient in-unit washers and dryers for your ultimate comfort.\n\nStep outside your door and indulge in an array of community amenities tailored to enhance your living experience. Dive into our sparkling pool or unwind in the rejuvenating hot tub and spa. Stay active at our fully equipped fitness center, or catch up with neighbors in our stylish clubhouse, equipped with a lounge and multi-use room. Enjoy the convenience of controlled access, 24-hour on-site maintenance, and package services, ensuring that your needs are met seamlessly.\n\nAt Echo Biltmore, eco-friendly living is a priority, featuring recycling programs and EV charging stations for our environmentally conscious residents. Our vibrant courtyard provides a serene atmosphere complete with grilling stations, while the breakfast and coffee concierge service adds an extra touch to your busy mornings. With high-speed internet access, a dedicated business center, and online services, working from home has never been easier.\n\nLocated in the heart of Phoenix, Echo Biltmore positions you near fantastic dining, shopping, and entertainment options, making it your perfect urban retreat. \n\nFind your new home today—browse our availability or schedule a tour to visit our beautiful community! Your dream apartment is waiting for you at Echo Biltmore.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019f6208-8c70-7049-af36-e944849748a2.webp",
  "property_featured_image_media": {
    "alt_text": "Swimming pool with lounge chairs and a covered seating area.",
    "public_id": "019f6208-8c70-7049-af36-e944849748a2",
    "storage_key": "property/6767906449166424/019f6208-8c70-7049-af36-e944849748a2.webp",
    "width": 3072,
    "height": 2048
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449166424/019f66a1-e43e-703f-80cf-85e472742efe.m4v",
  "property_featured_video_media": {
    "public_id": "019f66a1-e43e-703f-80cf-85e472742efe",
    "storage_key": "property/6767906449166424/019f66a1-e43e-703f-80cf-85e472742efe.m4v",
    "thumbnail_key": "property/6767906449166424/019f66a1-e43e-703f-80cf-85e472742efe_thumb.webp",
    "size_bytes": 35834853,
    "classification": "Community",
    "title": "Alta Biltmore Hero Video",
    "description": "Imported from Duda homepage hero background video"
  },
  "property_total_units": "215",
  "property_year_built": "2024",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "89.76744186046511",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "45",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Maximum 2 pets per apartment. Dogs or cats welcome.",
  "property_pet_policy_description": "Dogs or cats welcome. Maximum 2 pets per apartment. $500 non‑refundable pet fee per pet. $45 monthly pet rent per pet.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://echobiltmore.goprisma.com/auth/login",
  "property_apply_now_url": "https://myrentalapplication.com/index/amcechobiltmore",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02ca-671e-76af-a10d-988de45f2b82.webp",
  "property_primary_logo_media": {
    "alt_text": "Echo Biltmore Phoenix logo",
    "public_id": "019d02ca-671e-76af-a10d-988de45f2b82",
    "storage_key": "property/6767906449166424/019d02ca-671e-76af-a10d-988de45f2b82.webp",
    "width": 640,
    "height": 280
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02ca-9057-770c-8019-28a45d3f94b0.webp",
  "property_secondary_logo_media": {
    "alt_text": "Echo Biltmore Phoenix logo",
    "public_id": "019d02ca-9057-770c-8019-28a45d3f94b0",
    "storage_key": "property/6767906449166424/019d02ca-9057-770c-8019-28a45d3f94b0.webp",
    "width": 640,
    "height": 280
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02ca-87a5-726b-b0dd-d3a6558f0d47.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Alta Biltmore Phoenix logo",
    "public_id": "019d02ca-87a5-726b-b0dd-d3a6558f0d47",
    "storage_key": "property/6767906449166424/019d02ca-87a5-726b-b0dd-d3a6558f0d47.webp",
    "width": 193,
    "height": 80
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02ca-9057-770c-8019-28a45d3f94b0.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Echo Biltmore Phoenix logo",
    "public_id": "019d02ca-9057-770c-8019-28a45d3f94b0",
    "storage_key": "property/6767906449166424/019d02ca-9057-770c-8019-28a45d3f94b0.webp",
    "width": 640,
    "height": 280
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-5da7-768a-9221-bb30f19666be.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
  "property_company_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c4-532b-737e-bc65-d92182ca8ca4",
    "storage_key": "company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
    "width": 640,
    "height": 309
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Logo for Apartment Management Consultants with a house icon.",
    "public_id": "019f6696-c195-7642-9eb0-0a4d0423bad7",
    "storage_key": "company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
    "width": 320,
    "height": 154
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019f6696-f877-771a-b04d-e0c2089d85b0",
    "storage_key": "company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
    "width": 320,
    "height": 154
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#ffffff",
  "property_font_color": "#000000",
  "property_color_4": null,
  "property_color_3": "#eb0505",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": "#f9f9f9",
  "property_bedrooms_range": "Studio - 2",
  "property_bedrooms_min": "Studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "650 - 1224",
  "property_sqft_min": "650",
  "property_sqft_max": "1224",
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": null,
  "property_available_units": 22,
  "property_facebook_url": "https://www.facebook.com/echobiltmore/",
  "property_instagram_url": "https://www.instagram.com/echobiltmore/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ560gDi8NK4cRbEQxDTPMlm4",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/alta-biltmore-by-greystar-phoenix",
  "property_tiktok_url": "https://www.tiktok.com/@alta.biltmore",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Echo Biltmore",
  "property_home_romance_title": "Embrace the Joy of Living in Your Dream Home",
  "property_home_amenities_blurb": "At Echo Biltmore, Phoenix living reaches new heights. Choose from spacious one- and two-bedroom layouts featuring modern finishes like quartz countertops and stainless steel appliances. Unwind by the pool, energize in the fitness center, or relax in our spa. Enjoy seamless access to convenience, comfort, and vibrant community life!",
  "property_home_floorplans_blurb": "Welcome to Echo Biltmore, where modern living meets comfort in the heart of Phoenix, AZ. With thoughtfully designed one and two-bedroom floor plans, each space invites you to unwind and feel at home. Browse our available apartment homes to find the perfect layout that complements your lifestyle.",
  "property_home_gallery_blurb": "Welcome to Echo Biltmore, your oasis in Phoenix, AZ. Immerse yourself in beautifully designed one- and two-bedroom apartments featuring modern amenities like stainless steel appliances, hardwood floors, and spacious walk-in closets. Enjoy our resort-style pool, cutting-edge fitness center, and inviting clubhouse. Picture your perfect life here and relax in comfort!",
  "property_home_neighborhood_blurb": "At Echo Biltmore, embrace the vibrant heart of Phoenix, AZ, where culture and adventure await! With spacious one- and two-bedroom floor plans, you’re moments away from the Phoenix Art Museum, Children’s Museum, and lush Steele Indian School Park. Dive into a community rich with art, education, and outdoor fun!",
  "property_home_reviews_blurb": "Nestled in the heart of Phoenix's Biltmore district, Echo Biltmore offers a luxurious living experience that residents adore. Enjoy beautifully designed apartments and exceptional amenities, all complimented by our dedicated staff. \"The apartments are immaculate and very well designed,\" raves one resident. Discover your perfect new home today.",
  "property_neighborhood_blurb": "Nestled in the heart of Phoenix, Echo Biltmore is your gateway to vibrant culture and outdoor adventures. With easy access to renowned museums, educational institutions, and expansive parks, your lifestyle here will be enriched. Uncover the charm of nearby gems like the Japanese Friendship Garden and the Phoenix Art Museum.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Experience the vibrant lifestyle at Echo Biltmore in Phoenix, AZ, where modern comfort meets resort-style living. Enjoy our sparkling pool, state-of-the-art fitness center, and relaxing hot tub. Retreat to your spacious apartment with quartz countertops and ample storage, all within a community designed for your convenience and enjoyment.",
  "property_applynow_blurb": "Elevate your lifestyle at Echo Biltmore in Phoenix, AZ, where modern elegance meets unparalleled comfort. Choose from spacious one- and two-bedroom floor plans featuring stunning quartz countertops and hardwood floors. Enjoy resort-style amenities including a sparkling pool, fitness center, and relaxing spa. Lease online today to begin your new adventure!",
  "property_contactus_blurb": "At Echo Biltmore in vibrant Phoenix, AZ, we offer thoughtfully designed one and two-bedroom floor plans that elevate your living experience. Whether you're seeking cozy comfort or spacious elegance, our community caters to your lifestyle. Have questions? Reach out to our leasing team today for personalized assistance!",
  "property_faqs_blurb": "At Echo Biltmore in vibrant Phoenix, AZ, we offer a variety of thoughtfully designed floor plans, including one and two-bedroom apartments that suit your lifestyle. Have questions? Visit our FAQs page for all the insights you need about our community and what makes Echo Biltmore a perfect home!",
  "property_floorplans_blurb": "At Echo Biltmore in vibrant Phoenix, AZ, you’ll find thoughtfully designed one and two-bedroom apartment floor plans that fit your lifestyle. Each unique layout combines comfort and modern elegance, tailored for your needs. Browse our available apartment homes today and take the first step toward your ideal living space!",
  "property_gallery_blurb": "At Echo Biltmore in Phoenix, AZ, vibrant living thrives amidst stunning amenities and spacious floor plans. Picture yourself unwinding by the pool, enjoying a hot tub soak, or savoring morning coffee in our inviting clubhouse. With modern features and unparalleled convenience, your dream apartment awaits—step into serenity today!",
  "property_interactivemap_blurb": "At Echo Biltmore in Phoenix, your ideal apartment awaits, featuring spacious one and two-bedroom floor plans tailored for comfort. Our exceptional amenities, from the inviting pool to the invigorating fitness center, cater to every lifestyle. Utilize our interactive community map to uncover your next home sweet home today!",
  "property_pets_blurb": "At Echo Biltmore in Phoenix, AZ, your furry friends are part of the family! Each apartment accommodates up to two pets, with a welcoming environment designed for your pets to roam. Enjoy endless outdoor spaces where tails wag and adventures begin—all in a stylish community that feels like home.",
  "property_referafriend_blurb": "At Echo Biltmore in Phoenix, AZ, our vibrant community welcomes both one and two-bedroom floor plans tailored for your lifestyle. Share the joy of exceptional living—refer a friend today and build lasting memories together. Great friends make great neighbors, so let’s grow this extraordinary community, one friend at a time!",
  "property_residentaccess_blurb": "Welcome to Echo Biltmore, where modern living meets comfort in the heart of Phoenix, AZ. Select from our inviting one- and two-bedroom floor plans, designed for your lifestyle. Easily manage your home with our resident portal—pay rent, schedule maintenance, and stay connected with just a click!",
  "property_reviews_blurb": "Experience luxury living at Echo Biltmore, where residents rave about the “great living experience” in a beautifully designed, modern community. Enjoy top-notch amenities, quick maintenance responses, and a welcoming staff dedicated to making you feel at home. Join us in the vibrant Biltmore district, where convenience meets comfort!",
  "property_created_at": "1759782536823",
  "property_scheduletour_blurb": "At Echo Biltmore in vibrant Phoenix, AZ, find your perfect sanctuary among our thoughtfully designed one and two-bedroom floor plans. Experience unparalleled comfort and community living—don't just take our word for it; see what our residents are raving about! Schedule a tour today and envision your new home.",
  "property_thankyou_blurb": "Thank you for reaching out to Echo Biltmore in vibrant Phoenix, AZ! Our thoughtfully designed one and two-bedroom apartments are ready to welcome you. A member of our team will be in touch soon to guide you through your new home options. Your ideal living space awaits!",
  "property_virtualtours_blurb": "Step into Echo Biltmore, where vibrant Phoenix living meets stylish comfort. Choose from our thoughtfully designed one and two-bedroom floor plans, tailored to suit your lifestyle. Take a virtual tour today and envision your new home in this captivating community nestled in the heart of Arizona!",
  "property_copyright": "2025 All Rights Reserved. Echo Biltmore",
  "property_seo_title_home": "Echo Biltmore | Luxury Apartments in Phoenix, AZ",
  "property_seo_description_home": "Experience modern living at Echo Biltmore in Phoenix, AZ. Luxurious amenities, stunning studio, 1 and 2-bedroom floor plans, and a vibrant community await.",
  "property_seo_title_floorplans": "Floor Plans | Luxury Apartment Complexes in Phoenix, AZ",
  "property_seo_description_floorplans": "Find your ideal living space at Echo Biltmore in Phoenix! From cozy studios to spacious two-bedrooms, browse our unique floor plans today!",
  "property_seo_title_amenities": "Amenities | Pet Friendly Apartments in Phoenix, AZ",
  "property_seo_description_amenities": "Elevate your lifestyle at Echo Biltmore in Phoenix! Enjoy inviting amenities like a pool, fitness center, and stylish apartments designed for modern living.",
  "property_seo_title_gallery": "Gallery | Luxury Apartments in Biltmore, AZ",
  "property_seo_description_gallery": "Capture life at Echo Biltmore in Phoenix! Stunning amenities, spacious floor plans, and beautiful views await. Picture your perfect apartment lifestyle today!",
  "property_seo_title_virtualtours": "Virtual Tours | Luxury Apartments Biltmore Phoenix",
  "property_seo_description_virtualtours": "Experience Echo Biltmore in Phoenix, AZ! Take a virtual tour of our stylish studio, one- and two-bedroom apartments and find your perfect home today.",
  "property_seo_title_interactivemap": "Interactive Map | Luxury Apartments Phoenix",
  "property_seo_description_interactivemap": "Find your perfect home at Echo Biltmore in Phoenix! Use our interactive map to explore our stunning studio, 1 and 2-bedroom apartments and more!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Biltmore Area",
  "property_seo_description_neighborhood": "Explore the lively Biltmore neighborhood! Discover local favorites and hidden gems for the ultimate city experience in Phoenix.",
  "property_seo_title_contact": "Contact Us | Luxury Apartments in Phoenix, AZ",
  "property_seo_description_contact": "Contact Echo Biltmore in Phoenix, AZ for any inquiries! Our leasing team is ready to help you find your perfect studio, 1 or 2-bedroom home. Reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Phoenix, AZ",
  "property_seo_description_faqs": "Get answers about Echo Biltmore in Phoenix, AZ. Explore amenities and floor plans to help you choose your new home!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Phoenix, AZ",
  "property_seo_description_reviews": "Experience unmatched comfort at Echo Biltmore in Phoenix, AZ. Check out our residents' reviews and see why they love their home, amenities, and lifestyle!",
  "property_seo_title_applynow": "Apply Now | Apartments in Phoenix, AZ",
  "property_seo_description_applynow": "Elevate your lifestyle at Echo Biltmore in Phoenix, AZ. Enjoy stunning studio, 1 and 2-bedroom floor plans with top-tier amenities. Start your journey today!",
  "property_seo_title_residentaccess": "Resident Access | Echo Biltmore",
  "property_seo_description_residentaccess": "Log in to the Echo Biltmore resident portal for easy rent payments, maintenance requests, and community updates—your convenient living solution in Phoenix, AZ!",
  "property_seo_title_referafriend": "Refer A Friend | Echo Biltmore",
  "property_seo_description_referafriend": "Refer a friend to Echo Biltmore in Phoenix! Great friends make great neighbors—share the joy of vibrant living today and enjoy exclusive perks together!",
  "property_seo_title_scheduletour": "Schedule a Tour | Apartments in Phoenix, AZ",
  "property_seo_description_scheduletour": "Experience Echo Biltmore in Phoenix, AZ—where modern luxury meets vibrant community life. Schedule a tour today and step into your new home!",
  "property_seo_title_privacy": "Privacy Policy | Echo Biltmore | Phoenix, AZ",
  "property_seo_description_privacy": "At Echo Biltmore in Phoenix, your privacy matters. Learn how we protect your information and ensure a secure living experience. View our privacy policy today!",
  "property_seo_title_accessibility": "Accessibility | Echo Biltmore | Phoenix, AZ",
  "property_seo_description_accessibility": "At Echo Biltmore in Phoenix, AZ, we're committed to digital inclusion. Experience a community where accessibility meets vibrant living. Join us today!",
  "property_seo_title_sitemap": "Sitemap | Echo Biltmore | Phoenix, AZ",
  "property_seo_description_sitemap": "Uncover Echo Biltmore’s vibrant community in Phoenix, AZ. Navigate our sitemap to find your ideal apartment and immerse yourself in urban living today!",
  "property_seo_title_thankyou": "Thank You | Echo Biltmore | Phoenix, AZ",
  "property_seo_description_thankyou": "Thank you for reaching out to Echo Biltmore! A team member will be in touch soon to help you find your perfect home in vibrant Phoenix, AZ.",
  "property_seo_title_pets": "Pet Policy | Apartments in Phoenix, AZ",
  "property_seo_description_pets": "Echo Biltmore offers the best pet-friendly living in Phoenix, AZ. Check out our pet policy today and get one step closer to living with your furry friend.",
  "property_updated_at": "1786634683804",
  "amenities": [
    {
      "id": "ec_4d2edcf693fafafa7b0c4c99",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "generator",
      "external_id": "false",
      "title": "Resort Style Pool with Tanning Deck",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1178a8f826796da072a103c8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "generator",
      "external_id": "false",
      "title": "Speakeasy / Library Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f063c5e2395d9d6bcfc71368",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "generator",
      "external_id": "false",
      "title": "Wifi Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3eafd6695c9cdc53368c96a9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "generator",
      "external_id": "false",
      "title": "Fitness Center with Yoga",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d73079b87b85c8bef9ad60a8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "generator",
      "external_id": "false",
      "title": "Rooftop Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cf9e50a7f649f232a02c0c74",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "generator",
      "external_id": "false",
      "title": "Courtyard with Garden Games",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_20848657f1d9612f85883ba6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "generator",
      "external_id": "false",
      "title": "Entertainment Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_500e8a9cad2bd04347fe5faa",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "generator",
      "external_id": "false",
      "title": "BBQ Grills and Outdoor Entertainment Areas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3fe27dd3e7507a7f4241d390",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "generator",
      "external_id": "false",
      "title": "Micro Offices and Private Conference Suites",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1ab3dc944259bcf8ad96a0fa",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "generator",
      "external_id": "false",
      "title": "Car Charging Stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_17f8e91bb121720be03ad09f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "generator",
      "external_id": "false",
      "title": "Grey Kitchen Cabinetry with Pull Out Garbage Drawer and Soft‑Close Hinges",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c425d78b76a17dd91dcc6438",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "generator",
      "external_id": "false",
      "title": "GE® Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cd9e951c8d8c870d5714e0cd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "generator",
      "external_id": "false",
      "title": "Gas Ranges",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_76cbd232bc1969fff5425274",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "generator",
      "external_id": "false",
      "title": "French Door Refrigerators* and Vent Hoods* in Kitchens",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5b1145393004a5aa2b54fcf0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "generator",
      "external_id": "false",
      "title": "Quartz Kitchen Countertops with Tile Backsplash",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_adad8c82ad41066aa80c6a79",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "generator",
      "external_id": "false",
      "title": "Dormakaba Contactless Reader for Unit Entry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_894249fc8dacd33dbd5248ee",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "generator",
      "external_id": "false",
      "title": "Wood‑Style Plank Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9193377fbb09b3858fc840db",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "generator",
      "external_id": "false",
      "title": "Kohler® Bathroom Accessories",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_86286781a010bec12016ae26",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "generator",
      "external_id": "false",
      "title": "Illuminated Bathroom Mirrors and Frameless Showers",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_165f634e7ecb925cbffc2971",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "generator",
      "external_id": "false",
      "title": "GE® Full Size Washer and Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_01f9b988a7215af705f821d6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "generator",
      "external_id": "false",
      "title": "Tech Packages Available",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a2efeb0f62b721a836f0a810",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "generator",
      "external_id": "false",
      "title": "9′ Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_8eca2b52-d191-4d63-8ff7-4946a4aa03de",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019f6209-e379-705b-9879-081c9c6a2e05.webp",
      "image_media": {
        "alt_text": "Exterior of modern apartment building with balconies and large windows at sunset at Echo Biltmore in Phoenix AZ.",
        "public_id": "019f6209-e379-705b-9879-081c9c6a2e05",
        "storage_key": "property/6767906449166424/019f6209-e379-705b-9879-081c9c6a2e05.webp",
        "width": 1013,
        "height": 657
      },
      "title": "Community",
      "description": "Experience luxury living in this modern apartment community, featuring stylish exteriors and stunning sunset views.",
      "link": "",
      "alt_text": "Exterior of modern apartment building with balconies and large windows at sunset at Echo Biltmore in Phoenix AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f74e219f/dms3rep/multi/50812627458f849c0a58a6fcd31510c2-3e731a83-5b8a4ed9.png"
    },
    {
      "id": "custom_d275c550-1ffc-4b1f-a57a-0b6dcce878c3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c7-cb04-7371-87f7-e080b9be7606.webp",
      "image_media": {
        "alt_text": "Modern apartment lounge area with large waterfall artwork and fireplace at Echo Biltmore in Phoenix AZ.",
        "public_id": "019d02c7-cb04-7371-87f7-e080b9be7606",
        "storage_key": "property/6767906449166424/019d02c7-cb04-7371-87f7-e080b9be7606.webp",
        "width": 1800,
        "height": 1200
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish apartment lounge, featuring a stunning waterfall mural, comfortable seating, and a modern fireplace, perfect for socializing.",
      "link": "",
      "alt_text": "Modern apartment lounge area with large waterfall artwork and fireplace at Echo Biltmore in Phoenix AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f74e219f/dms3rep/multi/5742705921490944/6767906449166424/915603e3c81db89c68cf032824aae6c4.jpg"
    },
    {
      "id": "custom_22ab91f0-8447-4229-9ca3-300eabbde821",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c7-927f-743c-9891-081e4191c9b0.webp",
      "image_media": {
        "alt_text": "Billiard table and bar area in the apartment clubhouse lounge at Echo Biltmore in Phoenix AZ.",
        "public_id": "019d02c7-927f-743c-9891-081e4191c9b0",
        "storage_key": "property/6767906449166424/019d02c7-927f-743c-9891-081e4191c9b0.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Enjoy a game of billiards or relax at the bar in the resident lounge, a perfect space for socializing and entertainment.",
      "link": "",
      "alt_text": "Billiard table and bar area in the apartment clubhouse lounge at Echo Biltmore in Phoenix AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f74e219f/dms3rep/multi/5742705921490944/6767906449166424/689c610bf602e27b562bdef332361fb1.jpg"
    },
    {
      "id": "custom_6936dd53-52cc-4156-8bcd-10f077cddf55",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c7-94b9-749f-8ef1-bdc0c8a436ca.webp",
      "image_media": {
        "alt_text": "Modern lounge area with pool table and seating at Echo Biltmore in Phoenix AZ.",
        "public_id": "019d02c7-94b9-749f-8ef1-bdc0c8a436ca",
        "storage_key": "property/6767906449166424/019d02c7-94b9-749f-8ef1-bdc0c8a436ca.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Relax and entertain in our stylish community lounge, featuring a pool table, comfortable seating, and a full kitchen area.",
      "link": "",
      "alt_text": "Modern lounge area with pool table and seating at Echo Biltmore in Phoenix AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f74e219f/dms3rep/multi/5742705921490944/6767906449166424/0690dce29d4bb40310074380b4e407aa.jpg"
    },
    {
      "id": "custom_2275f494-1290-4e3f-a174-0dd60e493ec7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c7-9c5a-757a-a3c8-7a1d3cd2b79d.webp",
      "image_media": {
        "alt_text": "Modern lobby with seating area, fireplace, and abstract art at Echo Biltmore in Phoenix AZ.",
        "public_id": "019d02c7-9c5a-757a-a3c8-7a1d3cd2b79d",
        "storage_key": "property/6767906449166424/019d02c7-9c5a-757a-a3c8-7a1d3cd2b79d.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Experience the sophisticated comfort of our community lobby, featuring a cozy fireplace and elegant seating areas perfect for relaxing or socializing.",
      "link": "",
      "alt_text": "Modern lobby with seating area, fireplace, and abstract art at Echo Biltmore in Phoenix AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f74e219f/dms3rep/multi/5742705921490944/6767906449166424/896f20f4ffd06840560ba627aed9ba1e.jpg"
    },
    {
      "id": "custom_286e4297-452d-4439-941b-08b5fc09191f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c7-9ea1-7445-9afc-9d2b5c802f7a.webp",
      "image_media": {
        "alt_text": "Lobby seating area with marble floors and modern artwork at Echo Biltmore in Phoenix AZ.",
        "public_id": "019d02c7-9ea1-7445-9afc-9d2b5c802f7a",
        "storage_key": "property/6767906449166424/019d02c7-9ea1-7445-9afc-9d2b5c802f7a.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Relax and unwind in the stylish lobby seating area, featuring luxurious marble floors and contemporary artwork for a sophisticated ambiance.",
      "link": "",
      "alt_text": "Lobby seating area with marble floors and modern artwork at Echo Biltmore in Phoenix AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f74e219f/dms3rep/multi/5742705921490944/6767906449166424/fd34a5b78f5e5f55e650d2ad323896f9.jpg"
    },
    {
      "id": "custom_94bd0018-c275-4154-ab5b-a73467657f3a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c7-a987-72e4-b336-cc303d43890e.webp",
      "image_media": {
        "alt_text": "Luxurious lounge area with plush seating, elegant chandeliers, and modern decor.",
        "public_id": "019d02c7-a987-72e4-b336-cc303d43890e",
        "storage_key": "property/6767906449166424/019d02c7-a987-72e4-b336-cc303d43890e.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Relax and socialize in our sophisticated lounge, featuring comfortable booth seating, stunning chandeliers, and contemporary artwork for a welcoming ambiance.",
      "link": "",
      "alt_text": "Luxurious lounge area with plush seating, elegant chandeliers, and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f74e219f/dms3rep/multi/5742705921490944/6767906449166424/e8e91140bba6bc3ad62df913e98ef03c.jpg"
    },
    {
      "id": "custom_ad848e0e-9f5f-4d24-a35b-3f4cf7c58f6e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c7-ba1d-721b-8a62-66b86ea68d25.webp",
      "image_media": {
        "alt_text": "Modern fitness center with cardio machines and weight training equipment at Echo Biltmore in Phoenix AZ.",
        "public_id": "019d02c7-ba1d-721b-8a62-66b86ea68d25",
        "storage_key": "property/6767906449166424/019d02c7-ba1d-721b-8a62-66b86ea68d25.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "FEATURED",
      "link": "",
      "alt_text": "Modern fitness center with cardio machines and weight training equipment at Echo Biltmore in Phoenix AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f74e219f/dms3rep/multi/5742705921490944/6767906449166424/1800ec3f600d1a4c3be19e7ef3f0d56d.jpg"
    },
    {
      "id": "custom_b9d32d0b-32eb-44a6-a11f-dd3378b8fa4c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c7-beb5-736c-8878-43094fa7f245.webp",
      "image_media": {
        "alt_text": "Gym with cardio machines, weight equipment, and mirrors at Echo Biltmore in Phoenix AZ.",
        "public_id": "019d02c7-beb5-736c-8878-43094fa7f245",
        "storage_key": "property/6767906449166424/019d02c7-beb5-736c-8878-43094fa7f245.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio equipment, free weights, and a mirrored wall for your workout.",
      "link": "",
      "alt_text": "Gym with cardio machines, weight equipment, and mirrors at Echo Biltmore in Phoenix AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f74e219f/dms3rep/multi/5742705921490944/6767906449166424/b26b709421a704d1ceeeeae7daf9d622.jpg"
    },
    {
      "id": "custom_d9b4e2cb-944b-4374-abff-a4e1e17d0d04",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c7-c4f2-722e-943a-e95759a2675a.webp",
      "image_media": {
        "alt_text": "Fully equipped gym with weight racks, punching bag, and exercise benches.",
        "public_id": "019d02c7-c4f2-722e-943a-e95759a2675a",
        "storage_key": "property/6767906449166424/019d02c7-c4f2-722e-943a-e95759a2675a.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a variety of weight machines, free weights, and cardio equipment for a complete workout.",
      "link": "",
      "alt_text": "Fully equipped gym with weight racks, punching bag, and exercise benches.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f74e219f/dms3rep/multi/5742705921490944/6767906449166424/cc297659eb96026b3b2a02cc852f9d75.jpg"
    },
    {
      "id": "custom_3f72df75-d344-4ab2-8e05-aea7c58258cc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c7-65fa-731f-88fa-d66f244b518d.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and seating area",
        "public_id": "019d02c7-65fa-731f-88fa-d66f244b518d",
        "storage_key": "property/6767906449166424/019d02c7-65fa-731f-88fa-d66f244b518d.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "FEATURED",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and seating area",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f74e219f/dms3rep/multi/5742705921490944/6767906449166424/c8bad5843b21c74f01586641c611414b.jpg"
    },
    {
      "id": "custom_6e8e90f0-3ae3-46e8-b14f-65423de04a4f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c7-dd8b-715c-bee2-2987bc94ccd6.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and lounge area with building in background  at Echo Biltmore in Phoenix AZ.",
        "public_id": "019d02c7-dd8b-715c-bee2-2987bc94ccd6",
        "storage_key": "property/6767906449166424/019d02c7-dd8b-715c-bee2-2987bc94ccd6.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor pool, surrounded by comfortable seating and lush landscaping. The perfect place to relax and unwind.",
      "link": "",
      "alt_text": "Outdoor swimming pool and lounge area with building in background  at Echo Biltmore in Phoenix AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f74e219f/dms3rep/multi/5742705921490944/6767906449166424/a7d0dfc65d8f01ecc63b155f7157edc6.jpg"
    },
    {
      "id": "custom_99fe3c05-b3bf-46f2-84ac-4d4f714d63d8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c7-e013-77e6-8457-cbe44220e626.webp",
      "image_media": {
        "alt_text": "Rooftop lounge area with bar and mountain views at Echo Biltmore in Phoenix AZ.",
        "public_id": "019d02c7-e013-77e6-8457-cbe44220e626",
        "storage_key": "property/6767906449166424/019d02c7-e013-77e6-8457-cbe44220e626.webp",
        "width": 1800,
        "height": 1200
      },
      "title": "Community",
      "description": "Enjoy stunning mountain views from our rooftop lounge, complete with a full-service bar and comfortable seating. Perfect for socializing and unwinding.",
      "link": "",
      "alt_text": "Rooftop lounge area with bar and mountain views at Echo Biltmore in Phoenix AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f74e219f/dms3rep/multi/5742705921490944/6767906449166424/78817dea568ca021b113f2586aa6f389.jpg"
    },
    {
      "id": "custom_f6e6a59b-1605-439f-b7b1-d7b9709c6d12",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c7-fa2d-7458-afa8-80499c419659.webp",
      "image_media": {
        "alt_text": "Rooftop lounge area with grills, seating, and mountain views at sunset.",
        "public_id": "019d02c7-fa2d-7458-afa8-80499c419659",
        "storage_key": "property/6767906449166424/019d02c7-fa2d-7458-afa8-80499c419659.webp",
        "width": 1800,
        "height": 1200
      },
      "title": "Community",
      "description": "Enjoy breathtaking mountain views from the rooftop lounge, complete with comfortable seating and outdoor grills for the perfect evening.",
      "link": "",
      "alt_text": "Rooftop lounge area with grills, seating, and mountain views at sunset.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f74e219f/dms3rep/multi/5742705921490944/6767906449166424/57f1dd6b53652973a38f61861bb50a4d.jpg"
    },
    {
      "id": "custom_94631aa5-1637-4adf-812b-805147749068",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-0638-700d-a01e-d518abdcfea0.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with string lights, woven chairs, and a long communal table at Echo Biltmore in Phoenix AZ.",
        "public_id": "019d02c8-0638-700d-a01e-d518abdcfea0",
        "storage_key": "property/6767906449166424/019d02c8-0638-700d-a01e-d518abdcfea0.webp",
        "width": 1800,
        "height": 1200
      },
      "title": "Community",
      "description": "Enjoy breathtaking sunsets from our rooftop lounge, complete with comfortable seating, a communal dining table, and a modern outdoor kitchen.",
      "link": "",
      "alt_text": "Outdoor lounge area with string lights, woven chairs, and a long communal table at Echo Biltmore in Phoenix AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f74e219f/dms3rep/multi/5742705921490944/6767906449166424/5e792615eaab036e4777179525763b16.jpg"
    },
    {
      "id": "custom_7dd91eb0-72fb-4258-84c2-75fc8f03bd03",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-0324-716b-b99f-979e452a2d30.webp",
      "image_media": {
        "alt_text": "Outdoor patio with grills and seating area with mountain view at sunset",
        "public_id": "019d02c8-0324-716b-b99f-979e452a2d30",
        "storage_key": "property/6767906449166424/019d02c8-0324-716b-b99f-979e452a2d30.webp",
        "width": 1800,
        "height": 1200
      },
      "title": "Community",
      "description": "FEATURED",
      "link": "",
      "alt_text": "Outdoor patio with grills and seating area with mountain view at sunset",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f74e219f/dms3rep/multi/5742705921490944/6767906449166424/8d6141e23bcebfc56ddcd5178777c15c.jpg"
    },
    {
      "id": "custom_28865722-98fa-47b7-a670-ac829e3671ba",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c7-7360-72e7-b5fc-833335abbd9f.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island and balcony access at Echo Biltmore in Phoenix AZ.",
        "public_id": "019d02c7-7360-72e7-b5fc-833335abbd9f",
        "storage_key": "property/6767906449166424/019d02c7-7360-72e7-b5fc-833335abbd9f.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "FEATURED",
      "link": "",
      "alt_text": "Modern kitchen with island and balcony access at Echo Biltmore in Phoenix AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f74e219f/dms3rep/multi/5742705921490944/6767906449166424/7810d78e7d2065ee0b761fc155f9087b.jpg"
    },
    {
      "id": "custom_b5adc2b7-f38c-4e08-9b1e-461bab842967",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c7-6b2b-779f-b433-94bb33f4f8c5.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, gray cabinets, and a large sink at Echo Biltmore in Phoenix AZ.",
        "public_id": "019d02c7-6b2b-779f-b433-94bb33f4f8c5",
        "storage_key": "property/6767906449166424/019d02c7-6b2b-779f-b433-94bb33f4f8c5.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "Explore this stunning apartment kitchen featuring sleek gray cabinetry, a spacious stainless steel sink, and top-of-the-line appliances. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, gray cabinets, and a large sink at Echo Biltmore in Phoenix AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f74e219f/dms3rep/multi/5742705921490944/6767906449166424/f73f54099e1dc42b48ea38ceae05833c.jpg"
    },
    {
      "id": "custom_afe816d7-d754-4db1-861f-244c9ccc5181",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c7-68e8-725f-b14f-19ac4bbe9704.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, ample cabinet space, and quartz countertops.",
        "public_id": "019d02c7-68e8-725f-b14f-19ac4bbe9704",
        "storage_key": "property/6767906449166424/019d02c7-68e8-725f-b14f-19ac4bbe9704.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "Experience culinary convenience in this beautifully appointed apartment kitchen, featuring sleek cabinetry, modern appliances, and a spacious layout perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, ample cabinet space, and quartz countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f74e219f/dms3rep/multi/5742705921490944/6767906449166424/8d3dbde68e16bb352877435877b909ce.jpg"
    },
    {
      "id": "custom_77eea7f5-9ff5-4618-bcdc-fb7162aeda8a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c7-75f5-74aa-a2a6-03bac169c929.webp",
      "image_media": {
        "alt_text": "Modern living room and kitchen with white cabinets and stainless steel appliances at Echo Biltmore in Phoenix AZ.",
        "public_id": "019d02c7-75f5-74aa-a2a6-03bac169c929",
        "storage_key": "property/6767906449166424/019d02c7-75f5-74aa-a2a6-03bac169c929.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "Beautifully appointed living room and kitchen area, perfect for entertaining or relaxing.",
      "link": "",
      "alt_text": "Modern living room and kitchen with white cabinets and stainless steel appliances at Echo Biltmore in Phoenix AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f74e219f/dms3rep/multi/5742705921490944/6767906449166424/e37d6ee12871d3499a922bf7bdb0a61e.jpg"
    },
    {
      "id": "custom_b51bcba2-21a0-453a-84e1-07161d060015",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c7-75f4-767d-9030-ebf95d5cc09c.webp",
      "image_media": {
        "alt_text": "Cozy living room with a neutral-toned sofa, accent chair, coffee table, and artwork.",
        "public_id": "019d02c7-75f4-767d-9030-ebf95d5cc09c",
        "storage_key": "property/6767906449166424/019d02c7-75f4-767d-9030-ebf95d5cc09c.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "Spacious and inviting living room featuring a comfortable sofa, stylish accent chair, and decorative elements, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Cozy living room with a neutral-toned sofa, accent chair, coffee table, and artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f74e219f/dms3rep/multi/5742705921490944/6767906449166424/0feeed1749aa83a05c9be1e7d4e9f25d.jpg"
    },
    {
      "id": "custom_47cf8df0-d589-4ffa-97bb-1c90a46b639b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c7-7dc3-7583-988f-0c3fae11c315.webp",
      "image_media": {
        "alt_text": "King-size bed with plush bedding in a bedroom with accent wall at Echo Biltmore in Phoenix AZ.",
        "public_id": "019d02c7-7dc3-7583-988f-0c3fae11c315",
        "storage_key": "property/6767906449166424/019d02c7-7dc3-7583-988f-0c3fae11c315.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "Experience ultimate comfort in our spacious bedrooms, featuring a king-size bed and stylish decor.",
      "link": "",
      "alt_text": "King-size bed with plush bedding in a bedroom with accent wall at Echo Biltmore in Phoenix AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f74e219f/dms3rep/multi/5742705921490944/6767906449166424/051fdecb8ab7164f80a0f2f534a082f2.jpg"
    },
    {
      "id": "custom_d27d6a72-fe40-4ba5-b1a1-91c557e8a720",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c7-80e3-74b2-bf27-04d1e02d4e95.webp",
      "image_media": {
        "alt_text": "Hallway with a view into a laundry room featuring a washing machine and dryer at Echo Biltmore in Phoenix AZ.",
        "public_id": "019d02c7-80e3-74b2-bf27-04d1e02d4e95",
        "storage_key": "property/6767906449166424/019d02c7-80e3-74b2-bf27-04d1e02d4e95.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "Convenient in-unit laundry facilities, including a washing machine and dryer, are featured in this apartment's dedicated laundry room.",
      "link": "",
      "alt_text": "Hallway with a view into a laundry room featuring a washing machine and dryer at Echo Biltmore in Phoenix AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f74e219f/dms3rep/multi/5742705921490944/6767906449166424/e2610e5c86dc4a06ec5c49829ff42f7e.jpg"
    },
    {
      "id": "custom_757dfd73-b77a-4da5-b2c2-ca18714e38d0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c7-80c0-71c9-a333-0222e45249da.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, plush bedding, and a large window with city views at Echo Biltmore in Phoenix AZ.",
        "public_id": "019d02c7-80c0-71c9-a333-0222e45249da",
        "storage_key": "property/6767906449166424/019d02c7-80c0-71c9-a333-0222e45249da.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a king-size bed, soft linens, and ample natural light streaming through the large window.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-size bed, plush bedding, and a large window with city views at Echo Biltmore in Phoenix AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f74e219f/dms3rep/multi/5742705921490944/6767906449166424/6933c282fb774cc549930e04c915168f.jpg"
    },
    {
      "id": "custom_0d9c7087-32b5-4607-8c3a-0d23f32ea831",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c7-8417-757e-a41f-b1530e73a600.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a large lit vanity mirror, sink, toilet, and bathtub with shower at Echo Biltmore in Phoenix AZ.",
        "public_id": "019d02c7-8417-757e-a41f-b1530e73a600",
        "storage_key": "property/6767906449166424/019d02c7-8417-757e-a41f-b1530e73a600.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "Step into this sleek and modern bathroom, featuring a spacious vanity with an illuminated mirror, a comfortable toilet, and a relaxing bathtub with a shower.",
      "link": "",
      "alt_text": "Modern bathroom with a large lit vanity mirror, sink, toilet, and bathtub with shower at Echo Biltmore in Phoenix AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f74e219f/dms3rep/multi/5742705921490944/6767906449166424/211de6da64a44d5cd54942f6a131b039.jpg"
    },
    {
      "id": "custom_5e4d0c92-c1ae-4b0d-9121-54fd6a7b0d26",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c7-79ea-763c-b85a-376b142f0c06.webp",
      "image_media": {
        "alt_text": "Bedroom with a closet and bathroom access, featuring a dresser and a large round mirror at Echo Biltmore in Phoenix AZ.",
        "public_id": "019d02c7-79ea-763c-b85a-376b142f0c06",
        "storage_key": "property/6767906449166424/019d02c7-79ea-763c-b85a-376b142f0c06.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "Elegant bedroom with a spacious walk-in closet, en-suite bathroom access, and stylish decor including a dresser and a large round mirror reflecting the bed.",
      "link": "",
      "alt_text": "Bedroom with a closet and bathroom access, featuring a dresser and a large round mirror at Echo Biltmore in Phoenix AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/f74e219f/dms3rep/multi/5742705921490944/6767906449166424/358353418ca593892883042a419f3294.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_0bc06062-e27e-4eee-8f98-05b66591d619",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Blanco Cocina + Cantina",
      "poi_type": "Restaurants",
      "poi_address": "2502 E Camelback Rd #122, Phoenix, AZ 85016, USA",
      "poi_short_description": "Stylish Mexican eatery with outdoor seating for traditional eats & a wide range of tequilas.",
      "poi_long_description": "Stylish Mexican eatery with outdoor seating for traditional eats & a wide range of tequilas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-4ee8-7330-920b-6333ce9cbef2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-4ee8-7330-920b-6333ce9cbef2",
        "storage_key": "property/6767906449166424/019d02c8-4ee8-7330-920b-6333ce9cbef2.webp",
        "width": 1280,
        "height": 963
      },
      "poi_business_url": "https://www.blancotacostequila.com/locations/phoenix-az-biltmore-fashion-park/?utm_source=Google&utm_medium=Organic&utm_campaign=Maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=5831222121423744148&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blanco-cocina--cantina",
      "poi_latitude": "33.5103867",
      "poi_longitude": "-112.0284712",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 602-429-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b12b-763a-abde-5ff74e58d315.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b12b-763a-abde-5ff74e58d315",
        "storage_key": "property/6767906449166424/019d02c8-b12b-763a-abde-5ff74e58d315.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9_lRDGwNK4cRlKzc0Z-p7FA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_3548f1d8-6098-4941-a041-b636cc381a1b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "True Food Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "2502 E Camelback Rd Suite 135, Phoenix, AZ 85016, USA",
      "poi_short_description": "Relaxed, eco-chic chain serving health-conscious fare, including vegan options, plus cocktails.",
      "poi_long_description": "Relaxed, eco-chic chain serving health-conscious fare, including vegan options, plus cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-4eac-77da-8b42-9c4237a26f50.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-4eac-77da-8b42-9c4237a26f50",
        "storage_key": "property/6767906449166424/019d02c8-4eac-77da-8b42-9c4237a26f50.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.truefoodkitchen.com/locations/phoenix/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5440431876249256819&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "true-food-kitchen",
      "poi_latitude": "33.5103589",
      "poi_longitude": "-112.02769",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 602-774-3488",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b12b-763a-abde-5ff74e58d315.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b12b-763a-abde-5ff74e58d315",
        "storage_key": "property/6767906449166424/019d02c8-b12b-763a-abde-5ff74e58d315.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_T4sdGwNK4cRc4OMgPdLgEs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_c5cec9b3-b931-486f-b028-89f194398ecb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "The Capital Grille",
      "poi_type": "Restaurants",
      "poi_address": "2502 E Camelback Rd, Phoenix, AZ 85016, USA",
      "poi_short_description": "Outpost of the upscale steakhouse chain offers classic American fare & a clubby, refined setting.",
      "poi_long_description": "Outpost of the upscale steakhouse chain offers classic American fare & a clubby, refined setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-4eac-77da-8b42-9967ac4fb515.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-4eac-77da-8b42-9967ac4fb515",
        "storage_key": "property/6767906449166424/019d02c8-4eac-77da-8b42-9967ac4fb515.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.thecapitalgrille.com/locations/az/phoenix/phoenix/8017?cmpid=br:tcg_ag:ie_ch:loc_ca:TCGGMB_sn:gmb_gt:phoenix-az-8017_pl:locurl_rd:1013",
      "poi_directions_map_url": "https://maps.google.com/?cid=10408594178182247872&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-capital-grille",
      "poi_latitude": "33.510226",
      "poi_longitude": "-112.027072",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 602-952-8900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b12b-763a-abde-5ff74e58d315.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b12b-763a-abde-5ff74e58d315",
        "storage_key": "property/6767906449166424/019d02c8-b12b-763a-abde-5ff74e58d315.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_T4sdGwNK4cRwHXACULBcpA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fine_dining_restaurant"
    },
    {
      "id": "custom_18896742-7743-437c-9ac7-be7568b01d59",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Seasons 52",
      "poi_type": "Restaurants",
      "poi_address": "2502 E Camelback Rd Suite 140, Phoenix, AZ 85016, USA",
      "poi_short_description": "Rotating menu of seasonal American dishes alongside international wines in an upscale setting.",
      "poi_long_description": "Rotating menu of seasonal American dishes alongside international wines in an upscale setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-4ee4-70dd-b6e8-654aa2809c30.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-4ee4-70dd-b6e8-654aa2809c30",
        "storage_key": "property/6767906449166424/019d02c8-4ee4-70dd-b6e8-654aa2809c30.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "https://www.seasons52.com/locations/az/phoenix/phoenix/4517?cmpid=br:s52_ag:ie_ch:loc_ca:S52GMB_sn:gmb_gt:phoenix-az-4517_pl:locurl_rd:1016",
      "poi_directions_map_url": "https://maps.google.com/?cid=2747344481764541777&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seasons-52",
      "poi_latitude": "33.51044",
      "poi_longitude": "-112.02676",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 602-840-5252",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b12b-763a-abde-5ff74e58d315.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b12b-763a-abde-5ff74e58d315",
        "storage_key": "property/6767906449166424/019d02c8-b12b-763a-abde-5ff74e58d315.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_T4sdGwNK4cRUYU0B0CHICY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_76ab9881-cab4-461b-93f9-899652e1396c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Zinburger",
      "poi_type": "Restaurants",
      "poi_address": "2502 E Camelback Rd #127, Phoenix, AZ 85016, USA",
      "poi_short_description": "Local chain serving gourmet burgers & shakes, plus wine, beer & cocktails, in a hip, casual space.",
      "poi_long_description": "Local chain serving gourmet burgers & shakes, plus wine, beer & cocktails, in a hip, casual space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-548b-767f-aeb1-a6a72100db43.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-548b-767f-aeb1-a6a72100db43",
        "storage_key": "property/6767906449166424/019d02c8-548b-767f-aeb1-a6a72100db43.webp",
        "width": 520,
        "height": 870
      },
      "poi_business_url": "https://www.zinburgeraz.com/locations/phoenix-az/?utm_source=Google&utm_medium=Organic&utm_campaign=Maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=10321507628210720270&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "zinburger",
      "poi_latitude": "33.5103477",
      "poi_longitude": "-112.0281219",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 602-424-9500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b12b-763a-abde-5ff74e58d315.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b12b-763a-abde-5ff74e58d315",
        "storage_key": "property/6767906449166424/019d02c8-b12b-763a-abde-5ff74e58d315.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_T4sdGwNK4cRDg78jYBcPY8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_3513ab45-c83b-46f0-b9fb-b55f3d3c5a28",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Pomo Pizzeria - Biltmore",
      "poi_type": "Restaurants",
      "poi_address": "2502 E Camelback Rd STE A&B, Phoenix, AZ 85016, USA",
      "poi_short_description": "Italian eatery serving pizza and other classic dishes with beer, wine, and cocktails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-54ae-742b-a3c3-a90d36171a36.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-54ae-742b-a3c3-a90d36171a36",
        "storage_key": "property/6767906449166424/019d02c8-54ae-742b-a3c3-a90d36171a36.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.pomopizzeria.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=970133499049984707&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pomo-pizzeria---biltmore",
      "poi_latitude": "33.5106533",
      "poi_longitude": "-112.0265655",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 602-954-5221",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b12b-763a-abde-5ff74e58d315.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b12b-763a-abde-5ff74e58d315",
        "storage_key": "property/6767906449166424/019d02c8-b12b-763a-abde-5ff74e58d315.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJL04vDMoNK4cRw8KUA0ebdg0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_c7859907-184b-4a0f-9653-5a5a82539409",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Breakfast Club",
      "poi_type": "Restaurants",
      "poi_address": "2502 E Camelback Rd, Phoenix, AZ 85016, USA",
      "poi_short_description": "Bright, casual cafe providing coffee, breakfast standards & lunchtime sandwiches & salads.",
      "poi_long_description": "Bright, casual cafe providing coffee, breakfast standards & lunchtime sandwiches & salads.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-55ad-7216-a9d3-ebfcd64da710.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-55ad-7216-a9d3-ebfcd64da710",
        "storage_key": "property/6767906449166424/019d02c8-55ad-7216-a9d3-ebfcd64da710.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.breakfastclub.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3130670510812218232&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "breakfast-club",
      "poi_latitude": "33.5104317",
      "poi_longitude": "-112.0262496",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 602-661-3443",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b12b-763a-abde-5ff74e58d315.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b12b-763a-abde-5ff74e58d315",
        "storage_key": "property/6767906449166424/019d02c8-b12b-763a-abde-5ff74e58d315.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLyqKSLQNK4cReMPAGT5gcis",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_053068a9-f2e5-4b4f-b440-4912ace7a5cb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "BISUTORO Sushi Bar Grill",
      "poi_type": "Restaurants",
      "poi_address": "2502 E Camelback Rd #119, Phoenix, AZ 85016, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-55ad-7216-a9d3-e6016a259083.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-55ad-7216-a9d3-e6016a259083",
        "storage_key": "property/6767906449166424/019d02c8-55ad-7216-a9d3-e6016a259083.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bisutorosushi.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9076566931291797978&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bisutoro-sushi-bar-grill",
      "poi_latitude": "33.5102387",
      "poi_longitude": "-112.0289739",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 602-560-0033",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b12b-763a-abde-5ff74e58d315.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b12b-763a-abde-5ff74e58d315",
        "storage_key": "property/6767906449166424/019d02c8-b12b-763a-abde-5ff74e58d315.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJy7V5t80NK4cR2nm0x4hx9n0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_5fe54768-bb12-4080-8f6d-aa7063c1e7dc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Christopher’s at Wrigley Mansion",
      "poi_type": "Restaurants",
      "poi_address": "2501 E Telawa Trail, Phoenix, AZ 85016, USA",
      "poi_short_description": "French-inspired bistro fare is served at this upscale mall spot with modern decor & an open kitchen.",
      "poi_long_description": "French-inspired bistro fare is served at this upscale mall spot with modern decor & an open kitchen.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-58f9-70fb-9938-e0d6c8acee47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-58f9-70fb-9938-e0d6c8acee47",
        "storage_key": "property/6767906449166424/019d02c8-58f9-70fb-9938-e0d6c8acee47.webp",
        "width": 700,
        "height": 394
      },
      "poi_business_url": "http://wrigleymansion.com/christophers/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16556806921163913009&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "christophers-at-wrigley-mansion",
      "poi_latitude": "33.5228514",
      "poi_longitude": "-112.0267977",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 602-522-2344",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b12b-763a-abde-5ff74e58d315.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b12b-763a-abde-5ff74e58d315",
        "storage_key": "property/6767906449166424/019d02c8-b12b-763a-abde-5ff74e58d315.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_T4sdGwNK4cRMTe0TiyYxeU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_06aeb54f-dfb9-4bcf-b9cc-a73ee7fe8168",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "FLINT by Baltaire",
      "poi_type": "Restaurants",
      "poi_address": "2425 E Camelback Rd, Phoenix, AZ 85016, USA",
      "poi_short_description": "Mediterranean meals & craft cocktails in an upscale setting with an elegant midcentury-modern feel.",
      "poi_long_description": "Mediterranean meals & craft cocktails in an upscale setting with an elegant midcentury-modern feel.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-59fc-71ff-ad4d-41409e6418d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-59fc-71ff-ad4d-41409e6418d8",
        "storage_key": "property/6767906449166424/019d02c8-59fc-71ff-ad4d-41409e6418d8.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.flintbybaltaire.com/?y_source=1_MTAwMjE5NTA4My03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=3489780124740835134&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "flint-by-baltaire",
      "poi_latitude": "33.5089667",
      "poi_longitude": "-112.0278115",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 602-812-4818",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b12b-763a-abde-5ff74e58d315.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b12b-763a-abde-5ff74e58d315",
        "storage_key": "property/6767906449166424/019d02c8-b12b-763a-abde-5ff74e58d315.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ__eaSWwNK4cRPldlp4gwbjA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "custom_41fa3e75-8bb3-4fdd-afb2-28812cf5cddc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "THE MERCER",
      "poi_type": "Restaurants",
      "poi_address": "2525 E Camelback Rd #120, Phoenix, AZ 85016, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-5ab7-7293-a655-5222e776f730.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-5ab7-7293-a655-5222e776f730",
        "storage_key": "property/6767906449166424/019d02c8-5ab7-7293-a655-5222e776f730.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.themercerphx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=767509953272945271&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-mercer",
      "poi_latitude": "33.5087269",
      "poi_longitude": "-112.0275598",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 602-497-3696",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b12b-763a-abde-5ff74e58d315.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b12b-763a-abde-5ff74e58d315",
        "storage_key": "property/6767906449166424/019d02c8-b12b-763a-abde-5ff74e58d315.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJv0BrCB0NK4cRdxppbjy-pgo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_2ae812f7-f2f2-4eca-b669-45a65f281449",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "The Henry",
      "poi_type": "Restaurants",
      "poi_address": "4455 E Camelback Rd, Phoenix, AZ 85018, USA",
      "poi_short_description": "Elegant eatery with a patio, offering an American menu all day, along with a full bar.",
      "poi_long_description": "Elegant eatery with a patio, offering an American menu all day, along with a full bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-5ac7-7588-b7ab-19036a1268e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-5ac7-7588-b7ab-19036a1268e8",
        "storage_key": "property/6767906449166424/019d02c8-5ac7-7588-b7ab-19036a1268e8.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.thehenryrestaurant.com/locations/the-henry-phoenix/?utm_source=Google&utm_medium=Organic&utm_campaign=Maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=18203655143260475848&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-henry",
      "poi_latitude": "33.5088363",
      "poi_longitude": "-111.9841332",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 602-429-8020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b12b-763a-abde-5ff74e58d315.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b12b-763a-abde-5ff74e58d315",
        "storage_key": "property/6767906449166424/019d02c8-b12b-763a-abde-5ff74e58d315.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJawGHJfEMK4cRyNHA2-dfoPw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_7923d4dd-762b-4deb-a3b0-34911ea0c921",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Buck & Rider Phoenix",
      "poi_type": "Restaurants",
      "poi_address": "4225 E Camelback Rd, Phoenix, AZ 85018, USA",
      "poi_short_description": "Raw bar fare, meat dishes and craft drinks offered in a stylish dining room with patio seating.",
      "poi_long_description": "Raw bar fare, meat dishes and craft drinks offered in a stylish dining room with patio seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-5e57-755e-8283-30671bd00798.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-5e57-755e-8283-30671bd00798",
        "storage_key": "property/6767906449166424/019d02c8-5e57-755e-8283-30671bd00798.webp",
        "width": 880,
        "height": 586
      },
      "poi_business_url": "https://www.buckandrider.com/?utm_source=GMB&utm_medium=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=11728671695188025866&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "buck--rider-phoenix",
      "poi_latitude": "33.509183",
      "poi_longitude": "-111.988719",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 602-346-0110",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b12b-763a-abde-5ff74e58d315.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b12b-763a-abde-5ff74e58d315",
        "storage_key": "property/6767906449166424/019d02c8-b12b-763a-abde-5ff74e58d315.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1c1vcvoMK4cRCmLc_sOcxKI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_cd875221-16af-471e-b65a-82dc412e2f4e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Postino Arcadia",
      "poi_type": "Restaurants",
      "poi_address": "3939 E Campbell Ave #100, Phoenix, AZ 85018, USA",
      "poi_short_description": "Italian cafe serving a wide selection of bruschetta & wine in rustic-chic digs with outdoor seating.",
      "poi_long_description": "Italian cafe serving a wide selection of bruschetta & wine in rustic-chic digs with outdoor seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-5f47-74be-b5d5-f088c98cd015.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-5f47-74be-b5d5-f088c98cd015",
        "storage_key": "property/6767906449166424/019d02c8-5f47-74be-b5d5-f088c98cd015.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.postinowinecafe.com/locations/postino-arcadia",
      "poi_directions_map_url": "https://maps.google.com/?cid=15269607705781961356&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "postino-arcadia",
      "poi_latitude": "33.5021572",
      "poi_longitude": "-111.996314",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 602-852-3939",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b12b-763a-abde-5ff74e58d315.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b12b-763a-abde-5ff74e58d315",
        "storage_key": "property/6767906449166424/019d02c8-b12b-763a-abde-5ff74e58d315.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5fTXDP8MK4cRjIKzek6L6NM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_c3644778-f9c3-41a9-be0d-3a6edcbb7006",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "The Vig",
      "poi_type": "Restaurants",
      "poi_address": "4041 N 40th St, Phoenix, AZ 85018, USA",
      "poi_short_description": "Cool tavern offering Southwestern spins on pub grub, plus cocktails & regular live music.",
      "poi_long_description": "Cool tavern offering Southwestern spins on pub grub, plus cocktails & regular live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-60d4-76cd-a279-10f0ee0261b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-60d4-76cd-a279-10f0ee0261b8",
        "storage_key": "property/6767906449166424/019d02c8-60d4-76cd-a279-10f0ee0261b8.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.thevig.us/arcadia",
      "poi_directions_map_url": "https://maps.google.com/?cid=7976348364869365135&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-vig",
      "poi_latitude": "33.4944067",
      "poi_longitude": "-111.9950064",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 602-553-7227",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b12b-763a-abde-5ff74e58d315.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b12b-763a-abde-5ff74e58d315",
        "storage_key": "property/6767906449166424/019d02c8-b12b-763a-abde-5ff74e58d315.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJAZMB6lMMK4cRj23OzJOusW4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_5afc077a-a35f-4648-9274-038f5b50f467",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "4821 N 20th St, Phoenix, AZ 85016, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-63cb-7765-822f-2d1a9349cb12.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-63cb-7765-822f-2d1a9349cb12",
        "storage_key": "property/6767906449166424/019d02c8-63cb-7765-822f-2d1a9349cb12.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.traderjoes.com/az/phoenix/90/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=10694691880053583102&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "33.5070967",
      "poi_longitude": "-112.0377182",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 602-912-9022",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b12b-763a-abde-595233097880.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b12b-763a-abde-595233097880",
        "storage_key": "property/6767906449166424/019d02c8-b12b-763a-abde-595233097880.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoY_8TGQNK4cR_izZHJota5Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_95fd768a-272c-4be6-8fcd-ed40ff7ce797",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "4701 N 20th St, Phoenix, AZ 85016, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-64ae-70cf-8102-c68395cbf548.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-64ae-70cf-8102-c68395cbf548",
        "storage_key": "property/6767906449166424/019d02c8-64ae-70cf-8102-c68395cbf548.webp",
        "width": 1280,
        "height": 834
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/camelback?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=1444832490836523548&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "33.5064733",
      "poi_longitude": "-112.0376627",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 602-761-4750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b12b-763a-abde-595233097880.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b12b-763a-abde-595233097880",
        "storage_key": "property/6767906449166424/019d02c8-b12b-763a-abde-595233097880.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2-_kVWQNK4cRHPpA0H4TDRQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_c9eec68e-e651-429a-91f5-a46d4191f06a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Town & Country",
      "poi_type": "Shopping & Retail",
      "poi_address": "2021 E Camelback Rd, Phoenix, AZ 85016, USA",
      "poi_short_description": "Open-air mall with supermarkets, shops, services, fast food & a year-round, weekly farmer's market.",
      "poi_long_description": "Open-air mall with supermarkets, shops, services, fast food & a year-round, weekly farmer's market.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-6497-7423-9bd6-968380ba3ebc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-6497-7423-9bd6-968380ba3ebc",
        "storage_key": "property/6767906449166424/019d02c8-6497-7423-9bd6-968380ba3ebc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.townandcountryshops.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6280551528032066437&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "town--country",
      "poi_latitude": "33.5075495",
      "poi_longitude": "-112.037111",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 602-710-2122",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b12e-775f-9ca0-ed19566037ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b12e-775f-9ca0-ed19566037ec",
        "storage_key": "property/6767906449166424/019d02c8-b12e-775f-9ca0-ed19566037ec.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJFWeMkGUNK4cRhVvjxVYAKVc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_57ca1e6d-14eb-4619-b05e-75c52c9d3b3f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Camelback Colonnade",
      "poi_type": "Shopping & Retail",
      "poi_address": "1919 E Camelback Rd, Phoenix, AZ 85016, USA",
      "poi_short_description": "Contemporary shopping plaza featuring many big-box retailers & nationally popular restaurants.",
      "poi_long_description": "Contemporary shopping plaza featuring many big-box retailers & nationally popular restaurants.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-6711-773b-b901-432e58214be5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-6711-773b-b901-432e58214be5",
        "storage_key": "property/6767906449166424/019d02c8-6711-773b-b901-432e58214be5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.reddevelopment.com/camelback-colonnade/?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=16059148305903243770&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "camelback-colonnade",
      "poi_latitude": "33.5074256",
      "poi_longitude": "-112.0414466",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 480-348-3851",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b12e-775f-9ca0-ed19566037ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b12e-775f-9ca0-ed19566037ec",
        "storage_key": "property/6767906449166424/019d02c8-b12e-775f-9ca0-ed19566037ec.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ1eDZgGYNK4cR-tGtmEyO3d4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_99780d51-24ba-4109-a761-7fdaf8991252",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Nordstrom Rack",
      "poi_type": "Shopping & Retail",
      "poi_address": "2073 E Camelback Rd, Phoenix, AZ 85016, USA",
      "poi_short_description": "Chain department store selling shoes, clothing and accessories.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-68f8-73f9-85b5-353f1253d1c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-68f8-73f9-85b5-353f1253d1c2",
        "storage_key": "property/6767906449166424/019d02c8-68f8-73f9-85b5-353f1253d1c2.webp",
        "width": 668,
        "height": 486
      },
      "poi_business_url": "https://stores.nordstromrack.com/us/az/phoenix/2073-east-camelback-road?utm_source=google&utm_medium=organic&utm_campaign=rack&utm_content=367&utm_channel=low_nd_seo_local&sp_source=google&sp_campaign=rack",
      "poi_directions_map_url": "https://maps.google.com/?cid=16495841270176790008&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nordstrom-rack",
      "poi_latitude": "33.5078967",
      "poi_longitude": "-112.0367393",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 602-345-6880",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b12e-775f-9ca0-ed19566037ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b12e-775f-9ca0-ed19566037ec",
        "storage_key": "property/6767906449166424/019d02c8-b12e-775f-9ca0-ed19566037ec.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJBTVZdWYNK4cR-LUdjDwA7eQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_366cb67f-67fa-44d2-99ff-127fe42fa77c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Best Buy",
      "poi_type": "Shopping & Retail",
      "poi_address": "1949 E Camelback Rd #101, Phoenix, AZ 85016, USA",
      "poi_short_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_long_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-6ac5-769f-92f5-bb623d3b38fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-6ac5-769f-92f5-bb623d3b38fb",
        "storage_key": "property/6767906449166424/019d02c8-6ac5-769f-92f5-bb623d3b38fb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.bestbuy.com/az/phoenix/1949-e-camelback-rd-253.html/?ref=NS&loc=ns100",
      "poi_directions_map_url": "https://maps.google.com/?cid=9091829902457367054&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "best-buy",
      "poi_latitude": "33.5081284",
      "poi_longitude": "-112.040503",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 602-266-3400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b12e-775f-9ca0-ed19566037ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b12e-775f-9ca0-ed19566037ec",
        "storage_key": "property/6767906449166424/019d02c8-b12e-775f-9ca0-ed19566037ec.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ53TMP2QNK4cRDuo-LiCrLH4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "electronics_store"
    },
    {
      "id": "custom_cebc227a-b1e6-4a0d-b548-86b346109009",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Biltmore Fashion Park",
      "poi_type": "Shopping & Retail",
      "poi_address": "2502 E Camelback Rd, Phoenix, AZ 85016, USA",
      "poi_short_description": "Upscale shopping mall with high-end department stores & retailers, plus restaurants & fast food.",
      "poi_long_description": "Upscale shopping mall with high-end department stores & retailers, plus restaurants & fast food.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-6af3-76c9-9e4b-59abb719758e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-6af3-76c9-9e4b-59abb719758e",
        "storage_key": "property/6767906449166424/019d02c8-6af3-76c9-9e4b-59abb719758e.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.shopbiltmore.com/?utm_source=google&utm_medium=onlinesearch&utm_content=gmp_website_button&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=14989761710559018186&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "biltmore-fashion-park",
      "poi_latitude": "33.5108735",
      "poi_longitude": "-112.0279366",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 602-954-6810",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b12e-775f-9ca0-ed19566037ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b12e-775f-9ca0-ed19566037ec",
        "storage_key": "property/6767906449166424/019d02c8-b12e-775f-9ca0-ed19566037ec.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ_T4sdGwNK4cRyjyfSdtUBtA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_cbe78b3d-e55f-4be1-ae13-e6a3b97f9ee6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Saks Fifth Avenue",
      "poi_type": "Shopping & Retail",
      "poi_address": "2446 E Camelback Rd, Phoenix, AZ 85016, USA",
      "poi_short_description": "Posh department store chain carrying designer apparel, shoes & accessories, plus home goods & more.",
      "poi_long_description": "Posh department store chain carrying designer apparel, shoes & accessories, plus home goods & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-6c65-706c-9e40-25e3e85e3190.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-6c65-706c-9e40-25e3e85e3190",
        "storage_key": "property/6767906449166424/019d02c8-6c65-706c-9e40-25e3e85e3190.webp",
        "width": 1280,
        "height": 963
      },
      "poi_business_url": "https://www.saksfifthavenue.com/locations/s/phoenix",
      "poi_directions_map_url": "https://maps.google.com/?cid=6221853688722458526&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saks-fifth-avenue",
      "poi_latitude": "33.5111726",
      "poi_longitude": "-112.027949",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 602-955-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b12e-775f-9ca0-ed19566037ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b12e-775f-9ca0-ed19566037ec",
        "storage_key": "property/6767906449166424/019d02c8-b12e-775f-9ca0-ed19566037ec.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ4R1XPWwNK4cRnofBEPd2WFY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_35f4924f-e588-42bb-8b28-d28074861beb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "AJ's Fine Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "4430 E Camelback Rd, Phoenix, AZ 85018, USA",
      "poi_short_description": "Gourmet chain with butcher & seafood counters, baked goods & coffees, cheese & market-fresh produce.",
      "poi_long_description": "Gourmet chain with butcher & seafood counters, baked goods & coffees, cheese & market-fresh produce.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-6e25-773f-bd95-847d3116ab29.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-6e25-773f-bd95-847d3116ab29",
        "storage_key": "property/6767906449166424/019d02c8-6e25-773f-bd95-847d3116ab29.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ajsfinefoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8539842113276649358&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ajs-fine-foods",
      "poi_latitude": "33.5105509",
      "poi_longitude": "-111.9854313",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 602-522-0956",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b12b-763a-abde-595233097880.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b12b-763a-abde-595233097880",
        "storage_key": "property/6767906449166424/019d02c8-b12b-763a-abde-595233097880.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO4MB2O8MK4cRjp_G7yedg3Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_6a606558-2ce9-4860-b784-f56f19431941",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Madison Camelview Elementary School",
      "poi_type": "Education",
      "poi_address": "2002 E Campbell Ave, Phoenix, AZ 85016, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-7004-71af-a358-82ccff1b7b10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-7004-71af-a358-82ccff1b7b10",
        "storage_key": "property/6767906449166424/019d02c8-7004-71af-a358-82ccff1b7b10.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://madisonaz.org/camelview",
      "poi_directions_map_url": "https://maps.google.com/?cid=13260312902330132994&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "madison-camelview-elementary-school",
      "poi_latitude": "33.5032841",
      "poi_longitude": "-112.0381436",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 602-664-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b469-7412-9b82-4fa142c5fe52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b469-7412-9b82-4fa142c5fe52",
        "storage_key": "property/6767906449166424/019d02c8-b469-7412-9b82-4fa142c5fe52.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJNevz0XoNK4cRAqrqGVQYBrg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_c4468d20-f864-4225-9d09-2a4817e458c2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Camelback High School",
      "poi_type": "Education",
      "poi_address": "4612 N 28th St, Phoenix, AZ 85016, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-73f4-74e2-b9df-6721e3079576.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-73f4-74e2-b9df-6721e3079576",
        "storage_key": "property/6767906449166424/019d02c8-73f4-74e2-b9df-6721e3079576.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.pxu.org/camelback",
      "poi_directions_map_url": "https://maps.google.com/?cid=7785058341910835408&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "camelback-high-school",
      "poi_latitude": "33.5053947",
      "poi_longitude": "-112.0231711",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 602-764-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b469-7412-9b82-4fa142c5fe52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b469-7412-9b82-4fa142c5fe52",
        "storage_key": "property/6767906449166424/019d02c8-b469-7412-9b82-4fa142c5fe52.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJTb5T03INK4cR0HBJoVAVCmw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_4e9c754e-b799-44c3-89c3-7602c3ce2ef9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Madison No. 1 Middle School",
      "poi_type": "Education",
      "poi_address": "5525 N 16th St, Phoenix, AZ 85016, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-754f-737b-92a1-207f1d3b6202.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-754f-737b-92a1-207f1d3b6202",
        "storage_key": "property/6767906449166424/019d02c8-754f-737b-92a1-207f1d3b6202.webp",
        "width": 1000,
        "height": 562
      },
      "poi_business_url": "http://madisonaz.org/no1",
      "poi_directions_map_url": "https://maps.google.com/?cid=9698929619530693511&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "madison-no-1-middle-school",
      "poi_latitude": "33.5181532",
      "poi_longitude": "-112.0457283",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 602-664-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b469-7412-9b82-4fa142c5fe52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b469-7412-9b82-4fa142c5fe52",
        "storage_key": "property/6767906449166424/019d02c8-b469-7412-9b82-4fa142c5fe52.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJL48TX18NK4cRhzukERqFmYY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_740ec3af-ab79-49ce-9ac5-f31ee6942c59",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Southwest Human Development | Easterseals Southwest Human Development",
      "poi_type": "Education",
      "poi_address": "2850 N 24th St, Phoenix, AZ 85008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-7ca0-7718-b439-3b95cf928d48.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-7ca0-7718-b439-3b95cf928d48",
        "storage_key": "property/6767906449166424/019d02c8-7ca0-7718-b439-3b95cf928d48.webp",
        "width": 1024,
        "height": 683
      },
      "poi_business_url": "http://www.swhd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8683711516757076354&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southwest-human-development--easterseals-southwest-human-development",
      "poi_latitude": "33.4791561",
      "poi_longitude": "-112.030758",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 602-266-5976",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b489-7136-84c3-955c875af2d3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b489-7136-84c3-955c875af2d3",
        "storage_key": "property/6767906449166424/019d02c8-b489-7136-84c3-955c875af2d3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhUY9ymsNK4cRgilGwJ29gng",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_17214da3-3881-4847-9a2c-3758f3d8b8b5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Shemer Art Center and Museum",
      "poi_type": "Entertainment",
      "poi_address": "Shemer Art Center and Museum, 5005 E Camelback Rd, Phoenix, AZ 85018, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9731517619680759487&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shemer-art-center-and-museum",
      "poi_latitude": "33.504986",
      "poi_longitude": "-111.9720848",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b489-7136-84c3-955c875af2d3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b489-7136-84c3-955c875af2d3",
        "storage_key": "property/6767906449166424/019d02c8-b489-7136-84c3-955c875af2d3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpXFL3GEMK4cRv86GHrdLDYc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "premise"
    },
    {
      "id": "custom_0ba7aff2-8a97-4517-b55b-0efa17fdb7a4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "AMC DINE-IN Esplanade 14",
      "poi_type": "Entertainment",
      "poi_address": "2515 E Camelback Rd, Phoenix, AZ 85016, USA",
      "poi_short_description": "Movie theater chain offering 3D movies, and dine-in options from a full kitchen.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-7dbe-741b-94d8-153c0c5c1a83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-7dbe-741b-94d8-153c0c5c1a83",
        "storage_key": "property/6767906449166424/019d02c8-7dbe-741b-94d8-153c0c5c1a83.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/phoenix/amc-dine-in-esplanade-14?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=5314375406425123947&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-dine-in-esplanade-14",
      "poi_latitude": "33.5085087",
      "poi_longitude": "-112.0276523",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 602-667-0330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b48a-729c-8bad-0e75d809115c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b48a-729c-8bad-0e75d809115c",
        "storage_key": "property/6767906449166424/019d02c8-b48a-729c-8bad-0e75d809115c.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJSRDzo24NK4cRa6wKf0Z0wEk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_aa7e3dd0-66b2-4b0c-b868-78a47ec85749",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Geordie's at Wrigley Mansion",
      "poi_type": "Entertainment",
      "poi_address": "2501 E Telawa Trail, Phoenix, AZ 85016, USA",
      "poi_short_description": "Elegant, sprawling Italianate mansion built by William Wrigley, Jr., in 1929. Tours are offered.",
      "poi_long_description": "Elegant, sprawling Italianate mansion built by William Wrigley, Jr., in 1929. Tours are offered.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-802b-729e-a368-20f3c4ee5554.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-802b-729e-a368-20f3c4ee5554",
        "storage_key": "property/6767906449166424/019d02c8-802b-729e-a368-20f3c4ee5554.webp",
        "width": 1280,
        "height": 923
      },
      "poi_business_url": "http://www.wrigleymansion.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17126575715173478457&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "geordies-at-wrigley-mansion",
      "poi_latitude": "33.5234362",
      "poi_longitude": "-112.0269296",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 602-955-4079",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b12b-763a-abde-5ff74e58d315.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b12b-763a-abde-5ff74e58d315",
        "storage_key": "property/6767906449166424/019d02c8-b12b-763a-abde-5ff74e58d315.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFQj0IEcNK4cROTC_Wd_Rre0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_f18d3198-9698-4212-bc0a-97f1d98047e0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Phoenix Art Museum",
      "poi_type": "Entertainment",
      "poi_address": "1625 N Central Ave, Phoenix, AZ 85004, USA",
      "poi_short_description": "Expansive collection of acclaimed international art from the distant past to the present.",
      "poi_long_description": "Expansive collection of acclaimed international art from the distant past to the present.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-82bc-75eb-af85-3edde94969be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-82bc-75eb-af85-3edde94969be",
        "storage_key": "property/6767906449166424/019d02c8-82bc-75eb-af85-3edde94969be.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://phxart.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9100201502871915249&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "phoenix-art-museum",
      "poi_latitude": "33.4670863",
      "poi_longitude": "-112.0727721",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 602-257-1880",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b7a2-739b-965d-57f07120e080.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b7a2-739b-965d-57f07120e080",
        "storage_key": "property/6767906449166424/019d02c8-b7a2-739b-965d-57f07120e080.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJmcBGT0ASK4cR8QooSw1pSn4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_2fa4e856-62b3-471c-a88e-8a84804b8266",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Heard Museum",
      "poi_type": "Entertainment",
      "poi_address": "2301 N Central Ave, Phoenix, AZ 85004, USA",
      "poi_short_description": "Exhibits devoted to Native American  civilizations, including a big collection of Southwestern art.",
      "poi_long_description": "Exhibits devoted to Native American  civilizations, including a big collection of Southwestern art.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-86ab-7203-86e6-bc4097a7569c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-86ab-7203-86e6-bc4097a7569c",
        "storage_key": "property/6767906449166424/019d02c8-86ab-7203-86e6-bc4097a7569c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://heard.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15873792203703506722&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "heard-museum",
      "poi_latitude": "33.4725814",
      "poi_longitude": "-112.0722331",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 602-252-8840",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b7a2-739b-965d-57f07120e080.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b7a2-739b-965d-57f07120e080",
        "storage_key": "property/6767906449166424/019d02c8-b7a2-739b-965d-57f07120e080.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJq1ARW0ISK4cRItccBOgJS9w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_295e84b1-a38c-4fdc-b410-32a0eccdf5a7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Phoenix Zoo",
      "poi_type": "Entertainment",
      "poi_address": "455 N Galvin Pkwy, Phoenix, AZ 85008, USA",
      "poi_short_description": "125 acres of animal exhibits, including a children's area & petting zoo, plus a narrated tram ride.",
      "poi_long_description": "125 acres of animal exhibits, including a children's area & petting zoo, plus a narrated tram ride.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-8894-740e-8aec-2e827267f305.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-8894-740e-8aec-2e827267f305",
        "storage_key": "property/6767906449166424/019d02c8-8894-740e-8aec-2e827267f305.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.phoenixzoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7252865776953727344&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "phoenix-zoo",
      "poi_latitude": "33.4500374",
      "poi_longitude": "-111.9470063",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 11 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 602-286-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b489-7136-84c3-955c875af2d3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b489-7136-84c3-955c875af2d3",
        "storage_key": "property/6767906449166424/019d02c8-b489-7136-84c3-955c875af2d3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ3texLIOK4cRcBnqLv9ap2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_d7ea5dbe-f4cf-4ea0-9e7f-a806cfd4e457",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1610 E Camelback Rd, Phoenix, AZ 85016, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-5fd9-7658-9459-ee6ddbf7e0b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-5fd9-7658-9459-ee6ddbf7e0b3",
        "storage_key": "property/6767906449166424/019d02c8-5fd9-7658-9459-ee6ddbf7e0b3.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/phoenix-az-pharmacies/1610-e-camelback-rd-phoenix-az-85016/storeid=8366?WT.mc_id=LS_GOOGLE_RX_8366",
      "poi_directions_map_url": "https://maps.google.com/?cid=14819141855649651909&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "33.5095709",
      "poi_longitude": "-112.0470315",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 602-277-1727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b11e-75fa-b32c-99c29322c7e6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b11e-75fa-b32c-99c29322c7e6",
        "storage_key": "property/6767906449166424/019d02c8-b11e-75fa-b32c-99c29322c7e6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM1lN0GENK4cRxdwepgArqM0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_eb8024d7-7b95-4172-82f7-ed4799def92d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "4111 N 24th St, Phoenix, AZ 85016, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-8e0d-75dd-8e40-06e967e4ebc5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-8e0d-75dd-8e40-06e967e4ebc5",
        "storage_key": "property/6767906449166424/019d02c8-8e0d-75dd-8e40-06e967e4ebc5.webp",
        "width": 1280,
        "height": 584
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-4111+n+24th+st-phoenix-az-85016/id=4722",
      "poi_directions_map_url": "https://maps.google.com/?cid=17856745040512504314&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "33.4953316",
      "poi_longitude": "-112.0295781",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 602-381-0696",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b11e-75fa-b32c-99c29322c7e6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b11e-75fa-b32c-99c29322c7e6",
        "storage_key": "property/6767906449166424/019d02c8-b11e-75fa-b32c-99c29322c7e6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq58n_XUNK4cR-lF3WAHnz_c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_b925b0c3-4d16-47c7-bcee-9b1d191d5b91",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Life Time Biltmore",
      "poi_type": "Health and Wellness",
      "poi_address": "2580 E Camelback Rd, Phoenix, AZ 85016, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-8ffd-76ac-b813-59f8f6981974.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-8ffd-76ac-b813-59f8f6981974",
        "storage_key": "property/6767906449166424/019d02c8-8ffd-76ac-b813-59f8f6981974.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.lifetime.life/locations/az/biltmore.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=14753527583408917087&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "life-time-biltmore",
      "poi_latitude": "33.5106711",
      "poi_longitude": "-112.0257407",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 623-244-3200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b489-7136-84c3-955c875af2d3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b489-7136-84c3-955c875af2d3",
        "storage_key": "property/6767906449166424/019d02c8-b489-7136-84c3-955c875af2d3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH4exgSsNK4cRXwoEaSsPv8w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_7b86ad98-2667-431f-ac88-2d0b86a86ad9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2077 E Camelback Rd, Phoenix, AZ 85016, USA",
      "poi_short_description": "Clean chain for cardio, Pilates, yoga and strength training, plus a pool, basketball court and sauna.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-902b-750b-9fa6-6bf8e0104bf8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-902b-750b-9fa6-6bf8e0104bf8",
        "storage_key": "property/6767906449166424/019d02c8-902b-750b-9fa6-6bf8e0104bf8.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=232&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=17086058318366249808&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "33.5074129",
      "poi_longitude": "-112.0369734",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 602-241-9800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b489-7136-84c3-955c875af2d3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b489-7136-84c3-955c875af2d3",
        "storage_key": "property/6767906449166424/019d02c8-b489-7136-84c3-955c875af2d3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJre8va2wNK4cRUBPUxYPfHe0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b412af01-e6d5-4990-8917-d016c3e7e562",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Sweatshop on Central",
      "poi_type": "Health and Wellness",
      "poi_address": "100 E Camelback Rd #156, Phoenix, AZ 85012, USA",
      "poi_short_description": "Clean studio that offers yoga, barre and spin classes, plus instructors.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-91d6-72ff-9720-182dfac4a52e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-91d6-72ff-9720-182dfac4a52e",
        "storage_key": "property/6767906449166424/019d02c8-91d6-72ff-9720-182dfac4a52e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.sweatshopcentralphoenix.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2575712067555842564&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sweatshop-on-central",
      "poi_latitude": "33.5107969",
      "poi_longitude": "-112.0716669",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 602-835-5633",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b469-7412-9b82-4fa142c5fe52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b469-7412-9b82-4fa142c5fe52",
        "storage_key": "property/6767906449166424/019d02c8-b469-7412-9b82-4fa142c5fe52.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJi8FZ_LgSK4cRBFpajnrEviM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_c9545c72-a756-47c7-8aa3-92da84fcb950",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Biltmore Hot Yoga",
      "poi_type": "Health and Wellness",
      "poi_address": "2107 E Camelback Rd, Phoenix, AZ 85016, USA",
      "poi_short_description": "Yoga studio located in the Town and Country Shopping Center.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-921b-730a-9df6-e440741aab05.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-921b-730a-9df6-e440741aab05",
        "storage_key": "property/6767906449166424/019d02c8-921b-730a-9df6-e440741aab05.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://biltmorehotyoga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17824117304656253582&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "biltmore-hot-yoga",
      "poi_latitude": "33.5078499",
      "poi_longitude": "-112.0374588",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b469-7412-9b82-4fa142c5fe52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b469-7412-9b82-4fa142c5fe52",
        "storage_key": "property/6767906449166424/019d02c8-b469-7412-9b82-4fa142c5fe52.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQ0X6CwANK4cRjtLtmkD8W_c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_10e49654-6bae-4104-ac37-7ca47123df9e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Echo Canyon Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "E McDonald Dr, Phoenix, AZ 85018, USA",
      "poi_short_description": "Trailhead featuring a parking lot, restrooms & the start of a trail leading up Camelback Mountain.",
      "poi_long_description": "Trailhead featuring a parking lot, restrooms & the start of a trail leading up Camelback Mountain.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-820c-7592-81e1-490ec0b3e3ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-820c-7592-81e1-490ec0b3e3ca",
        "storage_key": "property/6767906449166424/019d02c8-820c-7592-81e1-490ec0b3e3ca.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11691523250841911723&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "echo-canyon-trailhead",
      "poi_latitude": "33.5213895",
      "poi_longitude": "-111.9735617",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b488-7238-b35c-db15f21f3d42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b488-7238-b35c-db15f21f3d42",
        "storage_key": "property/6767906449166424/019d02c8-b488-7238-b35c-db15f21f3d42.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJpRaTg5QMK4cRqwGnyXOiQKI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_1b7f6c2d-49f6-4447-9bb9-1944b6034503",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Cholla Trailhead Camelback Mountain",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5150 N Invergordon Rd, Phoenix, AZ 85253, USA",
      "poi_short_description": "Highly advanced mountain trail with steep climbs, rocky terrain & picturesque summit views.",
      "poi_long_description": "Highly advanced mountain trail with steep climbs, rocky terrain & picturesque summit views.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-9686-77cc-a9b5-6adc59fcee98.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-9686-77cc-a9b5-6adc59fcee98",
        "storage_key": "property/6767906449166424/019d02c8-9686-77cc-a9b5-6adc59fcee98.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.phoenix.gov/parks/trails/locations/camelback-mountain",
      "poi_directions_map_url": "https://maps.google.com/?cid=7201183621575773814&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cholla-trailhead-camelback-mountain",
      "poi_latitude": "33.5113454",
      "poi_longitude": "-111.9433859",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 602-261-8318",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b488-7238-b35c-db15f21f3d42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b488-7238-b35c-db15f21f3d42",
        "storage_key": "property/6767906449166424/019d02c8-b488-7238-b35c-db15f21f3d42.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0SGX7X4LK4cRdo5irlm-72M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_9484d0f6-dd0f-4af2-9d50-245cd8a5b6c3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Phoenix Mountains Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2701 Piestewa Peak Dr, Phoenix, AZ 85016, USA",
      "poi_short_description": "Group of parks with mountain & desert hiking trails, plus an abundance of cacti & native wildlife.",
      "poi_long_description": "Group of parks with mountain & desert hiking trails, plus an abundance of cacti & native wildlife.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-95d6-74cf-848c-845c208554fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-95d6-74cf-848c-845c208554fd",
        "storage_key": "property/6767906449166424/019d02c8-95d6-74cf-848c-845c208554fd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.phoenix.gov/parks/trails/locations/piestewa-peak",
      "poi_directions_map_url": "https://maps.google.com/?cid=768664447671239094&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "phoenix-mountains-preserve",
      "poi_latitude": "33.5620742",
      "poi_longitude": "-112.0209097",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 602-261-8318",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b488-7238-b35c-db15f21f3d42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b488-7238-b35c-db15f21f3d42",
        "storage_key": "property/6767906449166424/019d02c8-b488-7238-b35c-db15f21f3d42.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8UYsGO1yK4cRtoHqGj7Yqgo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_159cc305-465f-45c8-8cb0-460cad161729",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Hole in the Rock",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "625 N Galvin Pkwy, Phoenix, AZ 85008, USA",
      "poi_short_description": "Landmark rock formation with multiple cavelike holes in the sandstone created by erosion.",
      "poi_long_description": "Landmark rock formation with multiple cavelike holes in the sandstone created by erosion.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-893d-7261-8faa-2bc786f42bc0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-893d-7261-8faa-2bc786f42bc0",
        "storage_key": "property/6767906449166424/019d02c8-893d-7261-8faa-2bc786f42bc0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.phoenix.gov/parks/trails/locations/papago-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=385298564104506413&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hole-in-the-rock",
      "poi_latitude": "33.4564869",
      "poi_longitude": "-111.9452606",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 19 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 602-495-5458",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b488-7238-b35c-db15f21f3d42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b488-7238-b35c-db15f21f3d42",
        "storage_key": "property/6767906449166424/019d02c8-b488-7238-b35c-db15f21f3d42.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJdWuhyFEJK4cRLczqrQDbWAU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_0e9ae108-33fa-4721-8a8c-53256d0225f9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Desert Botanical Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1201 N Galvin Pkwy, Phoenix, AZ 85008, USA",
      "poi_short_description": "Desert garden with 50,000 plants spread over 140 acres, also offering dining, a gift shop & library.",
      "poi_long_description": "Desert garden with 50,000 plants spread over 140 acres, also offering dining, a gift shop & library.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-8767-7333-94e2-4f581337d6f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-8767-7333-94e2-4f581337d6f2",
        "storage_key": "property/6767906449166424/019d02c8-8767-7333-94e2-4f581337d6f2.webp",
        "width": 638,
        "height": 481
      },
      "poi_business_url": "https://dbg.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2404053162249248023&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "desert-botanical-garden",
      "poi_latitude": "33.4616795",
      "poi_longitude": "-111.944926",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 11 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 480-941-1225",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b488-7238-b35c-db15f21f3d42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b488-7238-b35c-db15f21f3d42",
        "storage_key": "property/6767906449166424/019d02c8-b488-7238-b35c-db15f21f3d42.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJIZ4tCFMJK4cRF10FJZ3pXCE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_70a741ea-9195-4387-9e02-d1da361518e7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Steele Indian School Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "300 E Indian School Rd, Phoenix, AZ 85012, USA",
      "poi_short_description": "Leafy lawned park around a lake with a playground, basketball & volleyball courts & picnic shelters.",
      "poi_long_description": "Leafy lawned park around a lake with a playground, basketball & volleyball courts & picnic shelters.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-977e-704f-a2fd-9e9b28cc3915.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-977e-704f-a2fd-9e9b28cc3915",
        "storage_key": "property/6767906449166424/019d02c8-977e-704f-a2fd-9e9b28cc3915.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.phoenix.gov/parks/parks/alphabetical/s-parks/steele-indian-school",
      "poi_directions_map_url": "https://maps.google.com/?cid=15561299676862919800&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "steele-indian-school-park",
      "poi_latitude": "33.5009135",
      "poi_longitude": "-112.0708073",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 602-495-0935",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b488-7238-b35c-db15f21f3d42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b488-7238-b35c-db15f21f3d42",
        "storage_key": "property/6767906449166424/019d02c8-b488-7238-b35c-db15f21f3d42.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJlcA-YY0SK4cReLTQ2pvX9Nc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ddb826c1-8353-4e37-bc45-d810bda3f3ef",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Camelback Rd & 16th St (Bus Stop)",
      "poi_type": "Transportation & Transit",
      "poi_address": "Phoenix, AZ 85016, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-9b29-7421-b2de-06cce7451ed6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-9b29-7421-b2de-06cce7451ed6",
        "storage_key": "property/6767906449166424/019d02c8-9b29-7421-b2de-06cce7451ed6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10207234496242615927&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "camelback-rd--16th-st",
      "poi_latitude": "33.5090794",
      "poi_longitude": "-112.0467659",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "6",
      "poi_biking_minutes": "1 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b489-7136-84c3-955c875af2d3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b489-7136-84c3-955c875af2d3",
        "storage_key": "property/6767906449166424/019d02c8-b489-7136-84c3-955c875af2d3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4f2ixGENK4cRd4anr7Fhp40",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_61249a41-4fa9-4d99-a460-fd4ce0a28827",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "24th St & Camelback Rd (Bus Stop)",
      "poi_type": "Transportation & Transit",
      "poi_address": "Phoenix, AZ 85016, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-9bfd-704d-85fd-08399b74690e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-9bfd-704d-85fd-08399b74690e",
        "storage_key": "property/6767906449166424/019d02c8-9bfd-704d-85fd-08399b74690e.webp",
        "width": 1255,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9292803811213750079&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "24th-st--camelback-rd",
      "poi_latitude": "33.5098991",
      "poi_longitude": "-112.0300105",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b489-7136-84c3-955c875af2d3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b489-7136-84c3-955c875af2d3",
        "storage_key": "property/6767906449166424/019d02c8-b489-7136-84c3-955c875af2d3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb3OxqG4NK4cRP6_KttSr9oA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_d76f413c-b9d9-4b06-a022-5e5019a2c6a0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "16th St & Highland Av (Bus Stop)",
      "poi_type": "Transportation & Transit",
      "poi_address": "Phoenix, AZ 85016, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-9cce-75df-9c5e-cb5a921c1ae5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-9cce-75df-9c5e-cb5a921c1ae5",
        "storage_key": "property/6767906449166424/019d02c8-9cce-75df-9c5e-cb5a921c1ae5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2926210927684071077&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "16th-st--highland-av",
      "poi_latitude": "33.5051727",
      "poi_longitude": "-112.0476605",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b489-7136-84c3-955c875af2d3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b489-7136-84c3-955c875af2d3",
        "storage_key": "property/6767906449166424/019d02c8-b489-7136-84c3-955c875af2d3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD6hveGINK4cRpa55wlX9myg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_34c13903-db24-430c-adc8-2283b0a525e2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Central Ave/Camelback (Bus Stop)",
      "poi_type": "Transportation & Transit",
      "poi_address": "Phoenix, AZ 85013, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-9cce-75df-9c5e-c5cde1e63ed6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-9cce-75df-9c5e-c5cde1e63ed6",
        "storage_key": "property/6767906449166424/019d02c8-9cce-75df-9c5e-c5cde1e63ed6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5057265574972164672&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-avecamelback",
      "poi_latitude": "33.5085962",
      "poi_longitude": "-112.0752921",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b489-7136-84c3-955c875af2d3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b489-7136-84c3-955c875af2d3",
        "storage_key": "property/6767906449166424/019d02c8-b489-7136-84c3-955c875af2d3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJERW-z8ESK4cRQAoH8z4EL0Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_ee1b1e9a-f15f-4ca0-9a4e-b8a048172d58",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Phoenix Children's Hospital - Thomas Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1919 E Thomas Rd, Phoenix, AZ 85016, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-a1b2-740f-8aea-3a2cbc1a1f22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-a1b2-740f-8aea-3a2cbc1a1f22",
        "storage_key": "property/6767906449166424/019d02c8-a1b2-740f-8aea-3a2cbc1a1f22.webp",
        "width": 470,
        "height": 313
      },
      "poi_business_url": "https://phoenixchildrens.org/locations/Phoenix/1919-E-Thomas-Rd",
      "poi_directions_map_url": "https://maps.google.com/?cid=6808680874366999376&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "phoenix-childrens-hospital---thomas-campus",
      "poi_latitude": "33.4792497",
      "poi_longitude": "-112.0419475",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 602-933-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b833-728e-a5eb-5b32c167a0b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b833-728e-a5eb-5b32c167a0b4",
        "storage_key": "property/6767906449166424/019d02c8-b833-728e-a5eb-5b32c167a0b4.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJeVRSn_8NK4cRUBukaS5LfV4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_3e79ab3a-3f1e-434b-aac9-f8e1a648665d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "St. Joseph's Hospital and Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "500 W Thomas Rd, Phoenix, AZ 85013, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-a6b7-7359-b017-1a81c954f151.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-a6b7-7359-b017-1a81c954f151",
        "storage_key": "property/6767906449166424/019d02c8-a6b7-7359-b017-1a81c954f151.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://phoenixmed.arizona.edu/st-joes",
      "poi_directions_map_url": "https://maps.google.com/?cid=7719312943935891418&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-josephs-hospital---neurology-department",
      "poi_latitude": "33.4816671",
      "poi_longitude": "-112.0808664",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "90",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 602-406-6262",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b489-7136-84c3-955c875af2d3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b489-7136-84c3-955c875af2d3",
        "storage_key": "property/6767906449166424/019d02c8-b489-7136-84c3-955c875af2d3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCZvMpVkSK4cR2qdfTTmCIGs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_5368778b-5eee-4015-8666-d4ec55245ca0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Banner - University Medical Center Phoenix | Phoenix, AZ | McDowell Rd.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1111 E McDowell Rd, Phoenix, AZ 85006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-8b97-756d-85d9-95c101e0d4e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-8b97-756d-85d9-95c101e0d4e2",
        "storage_key": "property/6767906449166424/019d02c8-8b97-756d-85d9-95c101e0d4e2.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.bannerhealth.com/locations/phoenix/banner-university-medical-center-phoenix?y_source=1_MTE5MDczNTMtNzE1LWxvY2F0aW9uLndlYnNpdGU=",
      "poi_directions_map_url": "https://maps.google.com/?cid=5784332207521473033&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "banner---university-medical-center-phoenix--phoenix-az--mcdowell-rd",
      "poi_latitude": "33.4645644",
      "poi_longitude": "-112.0573664",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 602-839-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b833-728e-a5eb-5b32c167a0b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b833-728e-a5eb-5b32c167a0b4",
        "storage_key": "property/6767906449166424/019d02c8-b833-728e-a5eb-5b32c167a0b4.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJoV6LoQ0SK4cRCSIr_H4TRlA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_70febdbe-5094-4224-bcbb-7a15cab5575c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Arizona Biltmore, LXR Hotels & Resorts",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2400 E Missouri Ave, Phoenix, AZ 85016, USA",
      "poi_short_description": "Lavish 1929 resort featuring 7 pools & 2 golf courses, plus 7 dining options & an on-site spa.",
      "poi_long_description": "Lavish 1929 resort featuring 7 pools & 2 golf courses, plus 7 dining options & an on-site spa.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-a769-7241-bdd3-e830a6069e8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-a769-7241-bdd3-e830a6069e8d",
        "storage_key": "property/6767906449166424/019d02c8-a769-7241-bdd3-e830a6069e8d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.arizonabiltmore.com/?utm_source=google&utm_medium=organic&utm_campaign=GMB-AMER-OL-PHXBMOL",
      "poi_directions_map_url": "https://maps.google.com/?cid=9326599692241325041&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arizona-biltmore-lxr-hotels--resorts",
      "poi_latitude": "33.522979",
      "poi_longitude": "-112.0232359",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 602-955-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-baa3-733e-907e-46132dc68610.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-baa3-733e-907e-46132dc68610",
        "storage_key": "property/6767906449166424/019d02c8-baa3-733e-907e-46132dc68610.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJ47o1_EENK4cR8ctPcgG9boE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hotel"
    },
    {
      "id": "custom_e292d48b-617a-4061-bd08-10377bd82caa",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Anchor Centre",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2201 E Camelback Rd, Phoenix, AZ 85016, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-a71d-753b-80ed-7b7a4735600f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-a71d-753b-80ed-7b7a4735600f",
        "storage_key": "property/6767906449166424/019d02c8-a71d-753b-80ed-7b7a4735600f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.anchorcentre.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7152173362174451883&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchor-centre",
      "poi_latitude": "33.50837",
      "poi_longitude": "-112.033394",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 602-955-7030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b489-7136-84c3-955c875af2d3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b489-7136-84c3-955c875af2d3",
        "storage_key": "property/6767906449166424/019d02c8-b489-7136-84c3-955c875af2d3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQAAwCQSK4cRq2BrcMefQWM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_942f8c5f-97f7-430e-b42f-c01d5952b74c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Camelback Lakes",
      "poi_type": "Major Employers & Offices",
      "poi_address": "E Camelback Rd, Phoenix, AZ 85016, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-a715-7063-a001-710e1b0103a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-a715-7063-a001-710e1b0103a0",
        "storage_key": "property/6767906449166424/019d02c8-a715-7063-a001-710e1b0103a0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4814644012802600423&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "camelback-lakes",
      "poi_latitude": "33.5103213",
      "poi_longitude": "-112.0218872",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b489-7136-84c3-955c875af2d3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b489-7136-84c3-955c875af2d3",
        "storage_key": "property/6767906449166424/019d02c8-b489-7136-84c3-955c875af2d3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgckoERMNK4cR520PdzgN0UI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_21de2dca-99eb-4bf7-9025-f412a5597c0e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Peak Group Llc",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5108 N 40th St # 3, Phoenix, AZ 85018, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.peakaz.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11170008533032136677&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "peak-group-llc",
      "poi_latitude": "33.51317",
      "poi_longitude": "-111.99794",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 602-952-0123",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b489-7136-84c3-955c875af2d3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b489-7136-84c3-955c875af2d3",
        "storage_key": "property/6767906449166424/019d02c8-b489-7136-84c3-955c875af2d3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzXVI7uIMK4cR5W92XZTXA5s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "real_estate_agency"
    },
    {
      "id": "custom_aafd8504-4b15-40fd-9d04-f2c7d98fc30a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Arizona State University Downtown Phoenix Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "411 N Central Ave, Phoenix, AZ 85004, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-abe2-75cc-96b1-b38f962c32b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-abe2-75cc-96b1-b38f962c32b8",
        "storage_key": "property/6767906449166424/019d02c8-abe2-75cc-96b1-b38f962c32b8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://tours.asu.edu/downtown",
      "poi_directions_map_url": "https://maps.google.com/?cid=10750644984180967322&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arizona-state-university-downtown-phoenix-campus",
      "poi_latitude": "33.4529982",
      "poi_longitude": "-112.0734572",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 602-496-4636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b469-7412-9b82-4fa142c5fe52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b469-7412-9b82-4fa142c5fe52",
        "storage_key": "property/6767906449166424/019d02c8-b469-7412-9b82-4fa142c5fe52.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJqY3-yCISK4cRmgdxXKf2MZU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_48343781-62b4-45a5-9e6d-fb4de359dace",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Superior Court of Arizona in Maricopa County",
      "poi_type": "Major Employers & Offices",
      "poi_address": "201 W Jefferson St, Phoenix, AZ 85003, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-ac45-77f7-9e77-334bf453957d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-ac45-77f7-9e77-334bf453957d",
        "storage_key": "property/6767906449166424/019d02c8-ac45-77f7-9e77-334bf453957d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.superiorcourt.maricopa.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11961017283213679818&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "superior-court-of-arizona-in-maricopa-county",
      "poi_latitude": "33.4464094",
      "poi_longitude": "-112.0756506",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 602-506-3204",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-bb59-757d-8d0c-8d484e78a90a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-bb59-757d-8d0c-8d484e78a90a",
        "storage_key": "property/6767906449166424/019d02c8-bb59-757d-8d0c-8d484e78a90a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv1CUJCESK4cRylxCztgR_qU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "courthouse"
    },
    {
      "id": "custom_213e0c9f-2301-485f-96db-153184610dd5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Phoenix City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "200 W Washington St, Phoenix, AZ 85003, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-abea-70fe-b251-d6291eab171b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-abea-70fe-b251-d6291eab171b",
        "storage_key": "property/6767906449166424/019d02c8-abea-70fe-b251-d6291eab171b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.phoenix.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6171114499780558672&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "phoenix-city-hall",
      "poi_latitude": "33.4487244",
      "poi_longitude": "-112.0773405",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 602-262-6011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-bb59-757d-8d0c-8d484e78a90a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-bb59-757d-8d0c-8d484e78a90a",
        "storage_key": "property/6767906449166424/019d02c8-bb59-757d-8d0c-8d484e78a90a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCTOCVyESK4cRUL-uC_EzpFU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_a0378088-892f-4a41-87dd-1fe2b4b892ac",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Chase Field",
      "poi_type": "Entertainment",
      "poi_address": "401 E Jefferson St, Phoenix, AZ 85004, USA",
      "poi_short_description": "Multipurpose venue that's home to Arizona Diamondbacks & host to other sporting events & concerts.",
      "poi_long_description": "Fans say this stadium offers a great fan experience with a retractable roof, air conditioning, and delicious hot dogs. They also highlight the friendly staff, clean facilities, and family-friendly atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019ef65f-b7e8-73b1-b4d0-b8201d36d08c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ef65f-b7e8-73b1-b4d0-b8201d36d08c",
        "storage_key": "property/6767906449166424/019ef65f-b7e8-73b1-b4d0-b8201d36d08c.webp",
        "width": 1242,
        "height": 540
      },
      "poi_business_url": "https://www.mlb.com/dbacks/ballpark/information",
      "poi_directions_map_url": "https://maps.google.com/?cid=7365694688292069982&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chase-field",
      "poi_latitude": "33.4453344",
      "poi_longitude": "-112.0667091",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 602-514-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c9-1445-77cb-8968-baae2f13002b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-1445-77cb-8968-baae2f13002b",
        "storage_key": "property/6767906449166424/019d02c9-1445-77cb-8968-baae2f13002b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8V7j8_URK4cRXmKhO0s0OGY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_f1bb568a-7269-40a6-9bb9-2ab691250e9d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Footprint Center",
      "poi_type": "Entertainment",
      "poi_address": "201 E Jefferson St, Phoenix, AZ 85004, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019ef65f-b8a4-733c-b6bd-283383db6b83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ef65f-b8a4-733c-b6bd-283383db6b83",
        "storage_key": "property/6767906449166424/019ef65f-b8a4-733c-b6bd-283383db6b83.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14543991172768734618&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "footprint-center",
      "poi_latitude": "33.445737",
      "poi_longitude": "-112.0712003",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b489-7136-84c3-955c875af2d3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b489-7136-84c3-955c875af2d3",
        "storage_key": "property/6767906449166424/019d02c8-b489-7136-84c3-955c875af2d3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdfhcbAATK4cRmh1MDeqi1sk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "point_of_interest"
    },
    {
      "id": "custom_897d6c9a-e7dd-4ac1-854e-397ed8556a62",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Arizona Science Center",
      "poi_type": "Entertainment",
      "poi_address": "600 E Washington St, Phoenix, AZ 85004, USA",
      "poi_short_description": "Science comes alive in this 4-story hands-on arena with live demos, a planetarium & an IMAX theater.",
      "poi_long_description": "Some visitors say this science museum offers a wide variety of interactive exhibits and hands-on activities, including a poison exhibit, a health section, and a makerspace, and they appreciate the educational value for kids of all ages.\n\nOther reviews mention many exhibits can be broken and the museum can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019ef65f-ba40-768d-866f-e42cb2e90677.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ef65f-ba40-768d-866f-e42cb2e90677",
        "storage_key": "property/6767906449166424/019ef65f-ba40-768d-866f-e42cb2e90677.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://azscience.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17330222221209878489&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "arizona-science-center",
      "poi_latitude": "33.4489422",
      "poi_longitude": "-112.0662283",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 602-716-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b7a2-739b-965d-57f07120e080.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b7a2-739b-965d-57f07120e080",
        "storage_key": "property/6767906449166424/019d02c8-b7a2-739b-965d-57f07120e080.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJLRHTlB4SK4cR2b_LbUpRgfA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_c266d9da-767f-46ad-a843-dbffec82cd90",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Musical Instrument Museum",
      "poi_type": "Entertainment",
      "poi_address": "4725 E Mayo Blvd, Phoenix, AZ 85050, USA",
      "poi_short_description": "Expansive display of instruments from roughly 200 countries, including some that guests can try out.",
      "poi_long_description": "Visitors say this museum offers an immersive experience with interactive exhibits, a vast collection of musical instruments from around the world, and a special exhibit featuring Stradivarius violins and guitars. They also highlight the friendly and helpful staff, the engaging audio tour, and the beautiful building and grounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019efa5a-f012-755c-b06d-139d5fe9eecf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019efa5a-f012-755c-b06d-139d5fe9eecf",
        "storage_key": "property/6767906449166424/019efa5a-f012-755c-b06d-139d5fe9eecf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://mim.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3729350831455392251&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "musical-instrument-museum",
      "poi_latitude": "33.6679904",
      "poi_longitude": "-111.9782969",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-478-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b7a2-739b-965d-57f07120e080.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b7a2-739b-965d-57f07120e080",
        "storage_key": "property/6767906449166424/019d02c8-b7a2-739b-965d-57f07120e080.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJfTp55hhxK4cR-9G0f9JQwTM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_f1f12f23-f081-4d0b-9564-931ea20a59dc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Old Town Scottsdale",
      "poi_type": "Entertainment",
      "poi_address": "N Scottsdale Rd, Scottsdale, AZ 85251, USA",
      "poi_short_description": "Lively area with preserved streets lined with unique shops, art galleries, and eateries.",
      "poi_long_description": "Visitors say this shopping area offers a wide variety of shops, including clothing stores, art galleries, and souvenir shops, as well as diverse dining options. They also highlight the western architecture and shaded areas, making it a fun place to explore. Guests mention the free parking and recommend wearing comfortable shoes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019efa5a-ed58-7400-b294-bb63c6e93e8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019efa5a-ed58-7400-b294-bb63c6e93e8d",
        "storage_key": "property/6767906449166424/019efa5a-ed58-7400-b294-bb63c6e93e8d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.scottsdaleaz.gov/old-town",
      "poi_directions_map_url": "https://maps.google.com/?cid=456044657923167465&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "old-town-scottsdale",
      "poi_latitude": "33.4945903",
      "poi_longitude": "-111.9248106",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-312-7177",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b12e-775f-9ca0-ed19566037ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b12e-775f-9ca0-ed19566037ec",
        "storage_key": "property/6767906449166424/019d02c8-b12e-775f-9ca0-ed19566037ec.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ2Z0yrr8LK4cR6ZQ5PTMyVAY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_74ee7222-c8e6-474e-92d3-18c0c07d8ae0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "South Mountain Park and Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10919 S Central Ave, Phoenix, AZ 85042, USA",
      "poi_short_description": "16,000-acre area with many trails, wildlife & a drivable road to a lookout with sweeping city views.",
      "poi_long_description": "People say this park offers extensive hiking trails for all skill levels and stunning panoramic views of the city and surrounding areas. Visitors also highlight the well-maintained trails, convenient parking, and clean restrooms. They also mention it's a peaceful and free resource, perfect for outdoor activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019efa5a-ec48-704e-8349-cedcec3831ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019efa5a-ec48-704e-8349-cedcec3831ff",
        "storage_key": "property/6767906449166424/019efa5a-ec48-704e-8349-cedcec3831ff.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.phoenix.gov/administration/departments/parks/activities-facilities/trails/south-mountain-parkpreserve.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=7241350686142470773&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "south-mountain-park-and-preserve",
      "poi_latitude": "33.3403368",
      "poi_longitude": "-112.0609473",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 602-495-5458",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b488-7238-b35c-db15f21f3d42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b488-7238-b35c-db15f21f3d42",
        "storage_key": "property/6767906449166424/019d02c8-b488-7238-b35c-db15f21f3d42.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJfybkSL8aK4cRdZqNLRVyfmQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_5a46f3ca-08af-41c0-9bc0-c6c52b2ea73f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Phoenix College",
      "poi_type": "Education",
      "poi_address": "1202 W Thomas Rd, Phoenix, AZ 85013, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019f050b-4ee7-74c1-abd2-3b116283bbe2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f050b-4ee7-74c1-abd2-3b116283bbe2",
        "storage_key": "property/6767906449166424/019f050b-4ee7-74c1-abd2-3b116283bbe2.webp",
        "width": 512,
        "height": 341
      },
      "poi_business_url": "http://www.phoenixcollege.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8690102689232332964&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "phoenix-college",
      "poi_latitude": "33.4831677",
      "poi_longitude": "-112.0892708",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 602-285-7777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b469-7412-9b82-4fa142c5fe52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b469-7412-9b82-4fa142c5fe52",
        "storage_key": "property/6767906449166424/019d02c8-b469-7412-9b82-4fa142c5fe52.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ32PXBlYSK4cRpChcjVpymXg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_d9fbaccb-bc05-4791-8028-d8b783cae24d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Century Library",
      "poi_type": "Education",
      "poi_address": "1750 E Highland Ave, Phoenix, AZ 85016, USA",
      "poi_short_description": "Cute but tiny library with friendly staff, plus computers, wifi and free passes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019f050b-4f60-702d-83aa-976b252a6fb3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f050b-4f60-702d-83aa-976b252a6fb3",
        "storage_key": "property/6767906449166424/019f050b-4f60-702d-83aa-976b252a6fb3.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.phoenixpubliclibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18426001049477801645&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "century-library",
      "poi_latitude": "33.5060239",
      "poi_longitude": "-112.0434158",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 602-262-4636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b469-7412-9b82-4fa142c5fe52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b469-7412-9b82-4fa142c5fe52",
        "storage_key": "property/6767906449166424/019d02c8-b469-7412-9b82-4fa142c5fe52.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ0XtYu2MNK4cRrWYZUVROtv8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_5ef5bc2e-1d3a-4188-ab1e-d0cc419e0436",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Phoenix Sky Harbor International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "3400 Sky Hbr Blvd, Phoenix, AZ 85034, USA",
      "poi_short_description": "This 3,000-acre airport serving the Phoenix area  features rail service & a variety of artwork.",
      "poi_long_description": "People say this airport offers a convenient sky train connecting terminals and the rental car center, and has a modern design with moving walkways. They also highlight the friendly staff, clean bathrooms, and easy navigation.\n\nOther reviews mention the airport can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-a0b2-7612-a027-88713dc8acc4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c8-a0b2-7612-a027-88713dc8acc4",
        "storage_key": "property/6767906449166424/019d02c8-a0b2-7612-a027-88713dc8acc4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.skyharbor.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9436507786966396482&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "phoenix-sky-harbor-international-airport",
      "poi_latitude": "33.435249",
      "poi_longitude": "-112.010124",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 602-273-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b857-72b1-b0a7-b4b1f8b819fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b857-72b1-b0a7-b4b1f8b819fa",
        "storage_key": "property/6767906449166424/019d02c8-b857-72b1-b0a7-b4b1f8b819fa.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJpXADM1wOK4cRQu5W4tU19YI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_bf899ab7-1051-4713-9cee-a93ebd2e5397",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Valley Metro Route 16 ((Bus Stop)",
      "poi_type": "Transportation & Transit",
      "poi_address": "",
      "poi_short_description": "16th St & Camelback Rd, Phoenix, AZ 85016",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_146f3506-a7ea-4967-87bd-4c48eb93b1e2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Biltmore Wellness",
      "poi_type": "Health and Wellness",
      "poi_address": "4742 N 24th St, Phoenix, AZ 85016, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/01a0a018-e38a-70f0-9ad0-9d2f14e486ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a018-e38a-70f0-9ad0-9d2f14e486ec",
        "storage_key": "property/6767906449166424/01a0a018-e38a-70f0-9ad0-9d2f14e486ec.webp",
        "width": 870,
        "height": 568
      },
      "poi_business_url": "https://biltmorewellness.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7906451239412732342&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "biltmore-wellness",
      "poi_latitude": "33.5072313",
      "poi_longitude": "-112.0307767",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-522-2065",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b489-7136-84c3-955c875af2d3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b489-7136-84c3-955c875af2d3",
        "storage_key": "property/6767906449166424/019d02c8-b489-7136-84c3-955c875af2d3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx_fG9gQNK4cRtpEkF4NbuW0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_9cf6ef74-c068-4a44-94a1-5e12d1b62c40",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Arcadia Wellness Center - Hormone, Weight Loss & Aesthetic Clinic in Phoenix, AZ",
      "poi_type": "Health and Wellness",
      "poi_address": "2850 E Camelback Rd Ste 175, Phoenix, AZ 85016, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/01a0a018-e270-7346-a52c-375b4412adc7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a018-e270-7346-a52c-375b4412adc7",
        "storage_key": "property/6767906449166424/01a0a018-e270-7346-a52c-375b4412adc7.webp",
        "width": 852,
        "height": 1136
      },
      "poi_business_url": "https://arcadiawellnesscenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18013566896550610519&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "arcadia-wellness-center---hormone-weight-loss--aesthetic-clinic-in-phoenix-az",
      "poi_latitude": "33.5101824",
      "poi_longitude": "-112.0208005",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-351-3688",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b489-7136-84c3-955c875af2d3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b489-7136-84c3-955c875af2d3",
        "storage_key": "property/6767906449166424/019d02c8-b489-7136-84c3-955c875af2d3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-Wf8rQgNK4cRV4aiBqcL_fk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wellness_center"
    },
    {
      "id": "custom_be769e91-c9cb-43f3-8e51-7e282a790376",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "poi_name": "Tangible Wellness Fitness Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1500 E Thomas Rd Ste 110, Phoenix, AZ 85014, USA",
      "poi_short_description": "Independent gym equipped with weights & cardio equipment also offering tanning & massages.",
      "poi_long_description": "People say this gym offers a wide variety of well-maintained equipment, including free weights, machines, and cardio options, with 24/7 access. They also highlight the consistently clean facilities, including spotless restrooms, and the friendly, helpful, and knowledgeable staff. Guests mention the welcoming and inclusive environment, noting it's rarely overcrowded and offers a good value.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/01a0a018-e57c-70c2-bdb0-446c12b1115a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a018-e57c-70c2-bdb0-446c12b1115a",
        "storage_key": "property/6767906449166424/01a0a018-e57c-70c2-bdb0-446c12b1115a.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "https://www.tangiblewellness.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12816798158586615562&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tangible-wellness-fitness-center",
      "poi_latitude": "33.4806006",
      "poi_longitude": "-112.0494849",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 602-274-4664",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-b489-7136-84c3-955c875af2d3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c8-b489-7136-84c3-955c875af2d3",
        "storage_key": "property/6767906449166424/019d02c8-b489-7136-84c3-955c875af2d3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRTHGZJESK4cRCpdv2ARq3rE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    }
  ],
  "office_hours": [
    {
      "id": "custom_a8174cfb-6600-41ef-8b60-d146f374ddaa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_50766a91-50e4-465f-a161-3ccc3c06062b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_8e161844-9cbb-4e94-8c68-5e8dafbdf0ef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_a38fe765-5bd2-4733-8e1c-28c642ccecbb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_84c30b73-450c-484d-94b2-6d6da3a155a2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_bfe9a77f-01ad-4f79-9f51-4c0519608eb6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_9833e420c3dc3ec2a8f43430",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "rating": "5",
      "name": "Jazmine Coleman",
      "text": "I moved to Arizona about 4 months ago. I had 3 days to find a place and on the last day I found Alta Biltmore. It has been nothing short of an amazing experience. The staff have always been very polite, helpful, and responsive. I absolutely love it here and I pray it continues to stay as great as it’s been. The application process was so easy and smooth. As a first time renter I appreciate how organized and simple it was to go through. Most importantly I love my apartment. It’s new and so far I haven’t had any issues with maintenance or my neighbors. Very grateful thus far.",
      "date": "2025-09-27",
      "title": "false"
    },
    {
      "id": "ec_d4958fabc023ad238d5ba500",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "rating": "5",
      "name": "shy w",
      "text": "I’ve had such a great experience living here! Destinee, Justine, and the entire team are always so kind, professional, and helpful. They truly go above and beyond for residents, which made it an easy decision to renew my lease. The community is well taken care of, and I genuinely enjoy living here. Highly recommend this apartment complex",
      "date": "2025-09-30",
      "title": "false"
    },
    {
      "id": "ec_68f691d90a5c567c99cdda06",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "rating": "5",
      "name": "Jacqueline Sterling",
      "text": "I am new to Phoenix and the people and staff at Alta have made me feel like I made the best decision coming from Dallas. Management is quick to assist with any concerns. Any maintenance request are typically handled within 24-48 hours and everyone is so friendly. The property is beautiful and my unit is very spacious. I would recommend 10/10",
      "date": "2025-09-26",
      "title": "false"
    },
    {
      "id": "ec_87cd826376c96abfdb0ec3c9",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "rating": "5",
      "name": "Ben Morgan",
      "text": "I just moved here recently. I had a great experience with the move-in process. Justice helped me out a lot and answered all of my questions. We did a virtual walk-through. Destiny was great getting me settled in. The amenities here are outstanding! Really nice pool, gym, garage. It’s very close to great stores and restaurants. It’s a pretty new building. So all the appliances are very nice! This is definitely one of the nicer places I’ve lived!\n\nEdit: a downside I have found since living here is it does get kind of noisy. I wear earplugs at night when I sleep. So that helps. But if you’re sensitive to noise, it’s something to consider. There are a lot of loud vehicles around the area at night.",
      "date": "2025-09-13",
      "title": "false"
    },
    {
      "id": "ec_2501b03fb469e5cd4b872ae9",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "rating": "5",
      "name": "Anes Issa",
      "text": "As we are entering our last month at this apartment complex, I would like to note this is a great place to be at with great amenities and group gatherings that help get the community together. Destinee has always been helpful with everything we needed. The only downside is that, we have had homeless people getting in the complex but that was resolved fast. Other than that it has been a pleasure living here.",
      "date": "2025-09-18",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_346304cd-0f09-4278-9dc4-9b9bdb812b83",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019f6c18-040b-771f-838e-957029b84f46.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-040b-771f-838e-957029b84f46",
        "storage_key": "property/6767906449166424/019f6c18-040b-771f-838e-957029b84f46.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Community Tour | Clubroom Lounge",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://viewer.panoskin.com/?id=virtualTour&tour=6753303b1b6cbae8655a286d&themeId=5db5f9bdd2988f1d481bb6b2&sourceId=2000"
    },
    {
      "id": "custom_4a1eb2fc-f18b-430c-9f7e-967829dbd02e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019f6c18-036c-77ba-bd0b-a6200614e977.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-036c-77ba-bd0b-a6200614e977",
        "storage_key": "property/6767906449166424/019f6c18-036c-77ba-bd0b-a6200614e977.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Community Tour | Social Lounge",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://viewer.panoskin.com/?id=virtualTour&tour=6753304b1b6cbae8655a2ae2&themeId=5db5f9bdd2988f1d481bb6b2&sourceId=2000"
    },
    {
      "id": "custom_cec487b1-ad3e-41cf-a57a-f664352964e4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019f6c18-0468-704f-85ea-9ee66cde50d9.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-0468-704f-85ea-9ee66cde50d9",
        "storage_key": "property/6767906449166424/019f6c18-0468-704f-85ea-9ee66cde50d9.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Apartment Tour | 1BR, 1BA | 777 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=YK7CKkUFxBS&play=1"
    },
    {
      "id": "custom_a4027e38-e03c-4ac5-871e-64175c976253",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019f6c18-0463-7113-b8f5-0d1a9baeb4a4.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-0463-7113-b8f5-0d1a9baeb4a4",
        "storage_key": "property/6767906449166424/019f6c18-0463-7113-b8f5-0d1a9baeb4a4.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Apartment Tour | 2BR, 2BA | 1104 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=imJmYBq6da4&play=1"
    },
    {
      "id": "custom_0b52dd3f-7247-4a4d-a1fb-3f47844c41b8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019f6c18-0448-7038-b168-d57e1de9ca41.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-0448-7038-b168-d57e1de9ca41",
        "storage_key": "property/6767906449166424/019f6c18-0448-7038-b168-d57e1de9ca41.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Apartment Tour | 1BR, 1BA | 771 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=KXGLDHa39wH&play=1"
    },
    {
      "id": "custom_59ca72de-e720-4831-9b81-784a1f0a4f59",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019f6c18-046a-74c8-abd1-23eeb3e87b6b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-046a-74c8-abd1-23eeb3e87b6b",
        "storage_key": "property/6767906449166424/019f6c18-046a-74c8-abd1-23eeb3e87b6b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Apartment Tour | 1BR, 1BA | 782 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=mi4TW3huLEi&play=1"
    },
    {
      "id": "custom_1f27f271-9ed9-4f0b-9cda-0635e3e13d7f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019f6c18-0448-7038-b168-d897e89da0d7.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-0448-7038-b168-d897e89da0d7",
        "storage_key": "property/6767906449166424/019f6c18-0448-7038-b168-d897e89da0d7.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Apartment Tour | 2BR, 2BA | 1098 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=8yfNGRzFXeN&play=1"
    },
    {
      "id": "custom_08adc2f6-2edb-494b-8d88-67d8d7334374",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019f6c18-0448-7038-b168-d0b684713b00.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-0448-7038-b168-d0b684713b00",
        "storage_key": "property/6767906449166424/019f6c18-0448-7038-b168-d0b684713b00.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Apartment Tour | 2BR, 2BA | 1143 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=YUSPoMfwAMT&play=1"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0199cf98-7451-701c-919a-2643a4ebc662",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "amc-echo-biltmore",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "generator",
      "page_item_url": "luxury-apartments-in-unit-laundry-phoenix",
      "search_query": "luxury apartments with in-unit laundry phoenix",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with In-Unit Laundry",
      "h2_subtitle": "Discover luxury apartments in the heart of Phoenix with in-unit laundry. Experience elegant living at Echo Biltmore, where convenience meets style.",
      "page_copy": "Welcome to Echo Biltmore, where luxury and convenience intertwine in central Phoenix. Our upscale apartments offer the perfect blend of sophisticated living and practical features. Located in the vibrant Camelback East Village, these luxury apartments come equipped with in-unit laundry facilities, making daily chores a breeze. \n\nChoose from our spacious one and two-bedroom floor plans, each showcasing modern finishes and floor-to-ceiling style. Beyond your apartment’s doors, indulge in resort-style amenities such as a sun-drenched pool, cutting-edge fitness center, and an elegant clubhouse. At Echo Biltmore, experience a lifestyle where every detail caters to your comfort and convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-4167-7389-a855-33f5f99356fb.webp",
      "featured_image_media": {
        "alt_text": "An outdoor swimming pool is the focal point of this courtyard, surrounded by apartment buildings and lounge areas.",
        "public_id": "019d02c8-4167-7389-a855-33f5f99356fb",
        "storage_key": "property/6767906449166424/019d02c8-4167-7389-a855-33f5f99356fb.webp",
        "width": 1518,
        "height": 854
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with In-Unit Laundry",
      "seo_description": "Explore Echo Biltmore's luxury apartments in Phoenix with in-unit laundry and premier amenities. Enjoy sophisticated living today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "generator",
      "page_item_url": "apartments-air-conditioning-camelback-east-village",
      "search_query": "apartments with air conditioning camelback east village",
      "category": "Amenity",
      "h1_title": "Apartments with Air Conditioning",
      "h2_subtitle": "Find the perfect apartment in Camelback East Village with air conditioning. Live comfortably at Echo Biltmore in Phoenix.",
      "page_copy": "Echo Biltmore in the vibrant Camelback East Village offers the perfect setting for comfortable living in Phoenix. Our apartments ensure residents stay cool and comfortable with modern air conditioning systems, adapting perfectly to Arizona’s climate. \n\nBeyond the climate control options, residents enjoy contemporary living spaces with stainless steel appliances and controlled access for added security. Echo Biltmore goes beyond just air conditioning, offering a selection of lifestyle amenities like a resort-style pool, well-equipped fitness center, and a welcoming clubhouse. Experience the ideal blend of comfort and style in these thoughtfully designed apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-4167-7389-a855-33f5f99356fb.webp",
      "featured_image_media": {
        "alt_text": "An outdoor swimming pool is the focal point of this courtyard, surrounded by apartment buildings and lounge areas.",
        "public_id": "019d02c8-4167-7389-a855-33f5f99356fb",
        "storage_key": "property/6767906449166424/019d02c8-4167-7389-a855-33f5f99356fb.webp",
        "width": 1518,
        "height": 854
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in Camelback East",
      "seo_description": "Stay cool at Echo Biltmore in Camelback East Village. Explore apartments with air conditioning and enjoy luxury amenities in Phoenix.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "generator",
      "page_item_url": "apartments-pool-maricopa-county",
      "search_query": "apartments with pool maricopa county",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Maricopa County",
      "h2_subtitle": "Explore Echo Biltmore's apartments featuring a stunning pool. Discover luxurious living in Maricopa County's prime location.",
      "page_copy": "At Echo Biltmore, located in the heart of Maricopa County, residents enjoy a luxury lifestyle enhanced by a pristine resort-style pool. Perfect for both relaxation and recreation, our pool area provides a tranquil escape from the hustle and bustle of city life. \n\nOur thoughtfully designed apartments offer more than just a pool. Choose from spacious one- and two-bedroom floor plans featuring contemporary finishes and high-end amenities like stainless steel appliances and in-unit washers. With a fitness center and clubhouse among other offerings, Echo Biltmore ensures you enjoy an elevated living experience within a vibrant community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-4167-7389-a855-33f5f99356fb.webp",
      "featured_image_media": {
        "alt_text": "An outdoor swimming pool is the focal point of this courtyard, surrounded by apartment buildings and lounge areas.",
        "public_id": "019d02c8-4167-7389-a855-33f5f99356fb",
        "storage_key": "property/6767906449166424/019d02c8-4167-7389-a855-33f5f99356fb.webp",
        "width": 1518,
        "height": 854
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool in Maricopa County",
      "seo_description": "Dive into luxury at Echo Biltmore in Maricopa County. Discover our apartments with a stunning pool and modern amenities today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "generator",
      "page_item_url": "apartments-fitness-center-phoenix-az",
      "search_query": "apartments with fitness center phoenix az",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center in Phoenix",
      "h2_subtitle": "Discover Echo Biltmore's apartments with a state-of-the-art fitness center. Embrace healthy living in Phoenix, AZ.",
      "page_copy": "Welcome to Echo Biltmore, where active lifestyles meet modern living in Phoenix, AZ. Our community offers residents a top-notch fitness center, equipped with the latest exercise equipment to help you stay fit and healthy without leaving home. \n\nAlongside the fitness center, Echo Biltmore's one and two-bedroom apartments are designed with comfort and style in mind. Enjoy luxury features like stainless steel appliances and in-unit laundry, all within a community offering resort-like amenities, including a sparkling pool and elegant clubhouse. Experience a balanced lifestyle combining fitness and luxury in Phoenix at Echo Biltmore.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-4167-7389-a855-33f5f99356fb.webp",
      "featured_image_media": {
        "alt_text": "An outdoor swimming pool is the focal point of this courtyard, surrounded by apartment buildings and lounge areas.",
        "public_id": "019d02c8-4167-7389-a855-33f5f99356fb",
        "storage_key": "property/6767906449166424/019d02c8-4167-7389-a855-33f5f99356fb.webp",
        "width": 1518,
        "height": 854
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Phoenix Apartments with Fitness Center",
      "seo_description": "Stay active at Echo Biltmore, Phoenix, AZ. Discover our apartments with a state-of-the-art fitness center and premium amenities today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "generator",
      "page_item_url": "apartments-dishwasher-echo-biltmore",
      "search_query": "apartments with dishwasher echo biltmore",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwasher at Echo Biltmore",
      "h2_subtitle": "Discover the convenience of a dishwasher in each apartment at Echo Biltmore. Enjoy hassle-free living in Phoenix, AZ.",
      "page_copy": "Echo Biltmore in Phoenix, AZ, offers residents the ultimate convenience with modern kitchens featuring dishwashers in every apartment. Say goodbye to the hassle of hand-washing dishes and enjoy more leisure time in our beautiful surroundings.\n\nBeyond the well-equipped kitchens, residents at Echo Biltmore benefit from a host of premium amenities. The community provides access to a resort-style pool, a fully equipped fitness center, and a modern clubhouse, all designed to enhance your lifestyle. Explore our spacious one and two-bedroom floor plans and experience convenient and luxurious living at its best.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-4167-7389-a855-33f5f99356fb.webp",
      "featured_image_media": {
        "alt_text": "An outdoor swimming pool is the focal point of this courtyard, surrounded by apartment buildings and lounge areas.",
        "public_id": "019d02c8-4167-7389-a855-33f5f99356fb",
        "storage_key": "property/6767906449166424/019d02c8-4167-7389-a855-33f5f99356fb.webp",
        "width": 1518,
        "height": 854
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Echo Biltmore: Apartments with Dishwasher",
      "seo_description": "Live conveniently at Echo Biltmore, Phoenix, AZ. Enjoy apartments that feature modern kitchens with dishwashers and premium community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "generator",
      "page_item_url": "one-bedroom-apts-camelback-east-village",
      "search_query": "one bedroom apartments camelback east village",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Camelback East",
      "h2_subtitle": "Explore one-bedroom apartments at Echo Biltmore, nestled in the vibrant Camelback East Village. Modern living meets convenience.",
      "page_copy": "Situated in the lively Camelback East Village, Echo Biltmore offers exceptional one-bedroom apartments that cater to those seeking both comfort and style. Our thoughtfully designed floor plans feature modern finishes and high-quality amenities, making it the perfect place to call home.\n\nResidents will find plenty of conveniences, including stainless steel appliances and the luxury of an in-unit washer and dryer. Beyond the individual apartments, Echo Biltmore offers access to a resort-style pool, a well-equipped fitness center, and a welcoming clubhouse, all designed to enhance your vibrant lifestyle in Phoenix, AZ. Discover the perfect blend of comfort and urban living in our one-bedroom apartments today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-4167-7389-a855-33f5f99356fb.webp",
      "featured_image_media": {
        "alt_text": "An outdoor swimming pool is the focal point of this courtyard, surrounded by apartment buildings and lounge areas.",
        "public_id": "019d02c8-4167-7389-a855-33f5f99356fb",
        "storage_key": "property/6767906449166424/019d02c8-4167-7389-a855-33f5f99356fb.webp",
        "width": 1518,
        "height": 854
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments at Echo Biltmore",
      "seo_description": "Experience cozy living at Echo Biltmore in Camelback East Village, Phoenix. Discover stylish one-bedroom apartments with upscale amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-phoenix-az",
      "search_query": "two bedroom apartments phoenix az",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Phoenix, AZ",
      "h2_subtitle": "Explore two-bedroom apartments at Echo Biltmore in Phoenix, AZ. Experience spacious living with premium amenities.",
      "page_copy": "Echo Biltmore in Phoenix, AZ, offers contemporary two-bedroom apartments designed for comfort and luxury. Residents enjoy expansive living spaces complemented by modern finishes, ensuring a perfect environment for relaxation or entertaining guests.\n\nOur community boasts high-end amenities including stainless steel appliances and controlled access, promoting a sense of security and modernity. With resort-style features such as a shimmering pool, state-of-the-art fitness center, and elegant clubhouse, Echo Biltmore provides everything you need to complement your active lifestyle. Discover the ideal blend of style, convenience, and comfort in our two-bedroom apartments today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-4167-7389-a855-33f5f99356fb.webp",
      "featured_image_media": {
        "alt_text": "An outdoor swimming pool is the focal point of this courtyard, surrounded by apartment buildings and lounge areas.",
        "public_id": "019d02c8-4167-7389-a855-33f5f99356fb",
        "storage_key": "property/6767906449166424/019d02c8-4167-7389-a855-33f5f99356fb.webp",
        "width": 1518,
        "height": 854
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments at Echo Biltmore",
      "seo_description": "Discover spacious two-bedroom apartments at Echo Biltmore, Phoenix, AZ. Enjoy modern living with resort-style amenities and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "generator",
      "page_item_url": "apartments-near-gcu-phoenix",
      "search_query": "apartments near grand canyon university phoenix",
      "category": "School",
      "h1_title": "Apartments Near Grand Canyon University",
      "h2_subtitle": "Discover Echo Biltmore's apartments close to Grand Canyon University in Phoenix. Enjoy a blend of convenience and luxury.",
      "page_copy": "Conveniently located near Grand Canyon University, Echo Biltmore offers stylish apartments that provide both comfort and accessibility. Our community is ideal for students and faculty members seeking a convenient housing option in Phoenix, AZ.\n\nAt Echo Biltmore, you'll find spacious one and two-bedroom floor plans featuring premium amenities such as stainless steel appliances and in-unit dishwashers. Beyond the apartments, enjoy access to our resort-style pool, modern fitness center, and inviting clubhouse—creating a welcoming home environment just minutes from GCU. Embrace convenient living in a vibrant community today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-4167-7389-a855-33f5f99356fb.webp",
      "featured_image_media": {
        "alt_text": "An outdoor swimming pool is the focal point of this courtyard, surrounded by apartment buildings and lounge areas.",
        "public_id": "019d02c8-4167-7389-a855-33f5f99356fb",
        "storage_key": "property/6767906449166424/019d02c8-4167-7389-a855-33f5f99356fb.webp",
        "width": 1518,
        "height": 854
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near GCU at Echo Biltmore",
      "seo_description": "Find luxurious apartments near Grand Canyon University, Phoenix at Echo Biltmore. Enjoy top-tier amenities and convenient living close to campus.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "generator",
      "page_item_url": "apartments-close-phoenix-college-camelback",
      "search_query": "apartments close to phoenix college camelback east",
      "category": "School",
      "h1_title": "Apartments Close to Phoenix College",
      "h2_subtitle": "Echo Biltmore offers apartments near Phoenix College in Camelback East Village. Enjoy modern amenities and convenient living.",
      "page_copy": "Echo Biltmore provides the perfect home base for students and faculty with its proximity to Phoenix College in Camelback East Village. Our community offers modern, comfortable living options with easy access to campus and the conveniences of Phoenix.\n\nChoose from our stylish one or two-bedroom apartments, each equipped with state-of-the-art amenities such as stainless steel appliances and controlled access for peace of mind. Residents can also enjoy the resort-like pool, a fully-equipped fitness center, and a vibrant clubhouse, making downtime both enjoyable and convenient. Experience the ideal blend of location, luxury, and lifestyle at Echo Biltmore.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-4167-7389-a855-33f5f99356fb.webp",
      "featured_image_media": {
        "alt_text": "An outdoor swimming pool is the focal point of this courtyard, surrounded by apartment buildings and lounge areas.",
        "public_id": "019d02c8-4167-7389-a855-33f5f99356fb",
        "storage_key": "property/6767906449166424/019d02c8-4167-7389-a855-33f5f99356fb.webp",
        "width": 1518,
        "height": 854
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Phoenix College at Echo Biltmore",
      "seo_description": "Experience convenient living near Phoenix College at Echo Biltmore, Camelback East. Discover luxurious apartments with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "generator",
      "page_item_url": "housing-near-gateway-community-college",
      "search_query": "housing by gateway community college maricopa county",
      "category": "School",
      "h1_title": "Housing by Gateway Community College",
      "h2_subtitle": "Echo Biltmore offers housing near Gateway Community College in Maricopa County. Experience ease and luxury.",
      "page_copy": "Located conveniently close to Gateway Community College in Maricopa County, Echo Biltmore provides an ideal housing solution for students and staff alike. Our community ensures easy commuting coupled with luxurious living amenities.\n\nEcho Biltmore features thoughtfully designed one and two-bedroom apartments that cater to the needs of college residents. Enjoy premium features like stainless steel appliances, and benefit from our resort-style amenities including a sparkling pool, cutting-edge fitness center, and an engaging clubhouse. Make Echo Biltmore your sanctuary in the heart of Phoenix, where convenience meets comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-4167-7389-a855-33f5f99356fb.webp",
      "featured_image_media": {
        "alt_text": "An outdoor swimming pool is the focal point of this courtyard, surrounded by apartment buildings and lounge areas.",
        "public_id": "019d02c8-4167-7389-a855-33f5f99356fb",
        "storage_key": "property/6767906449166424/019d02c8-4167-7389-a855-33f5f99356fb.webp",
        "width": 1518,
        "height": 854
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Housing Near Gateway Community College",
      "seo_description": "Discover premium housing near Gateway Community College at Echo Biltmore, Maricopa County. Convenient living with exceptional amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "generator",
      "page_item_url": "apartments-near-banner-university-medical-center",
      "search_query": "apartments near Banner University Medical Center Phoenix",
      "category": "Hospital",
      "h1_title": "Apartments Near Banner University Medical Center",
      "h2_subtitle": "Find Echo Biltmore apartments near Banner University Medical Center in Phoenix. Enjoy a luxurious and convenient lifestyle.",
      "page_copy": "Echo Biltmore is ideally situated near Banner University Medical Center, offering a perfect blend of comfort and convenience for healthcare professionals and students in Phoenix. Our modern apartments are just a short commute away, making daily travel simple and stress-free.\n\nChoose from our spacious one or two-bedroom floor plans, featuring high-end finishes such as stainless steel appliances and in-unit dishwashers. With exclusive community amenities like a resort-style pool, a fitness center, and a welcoming clubhouse, Echo Biltmore provides a sanctuary after a busy day at the medical center. Experience optimum living with seamless connectivity and relaxation at Echo Biltmore.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-4167-7389-a855-33f5f99356fb.webp",
      "featured_image_media": {
        "alt_text": "An outdoor swimming pool is the focal point of this courtyard, surrounded by apartment buildings and lounge areas.",
        "public_id": "019d02c8-4167-7389-a855-33f5f99356fb",
        "storage_key": "property/6767906449166424/019d02c8-4167-7389-a855-33f5f99356fb.webp",
        "width": 1518,
        "height": 854
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Banner University Medical Center",
      "seo_description": "Live near Banner University Medical Center at Echo Biltmore, Phoenix. Enjoy stylish apartments and excellent amenities with easy access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "generator",
      "page_item_url": "echo-biltmore-apartments-near-phoenix-childrens-hospital",
      "search_query": "Echo Biltmore apartments close to Phoenix Children's Hospital",
      "category": "Hospital",
      "h1_title": "Echo Biltmore Apartments Near Phoenix Children's",
      "h2_subtitle": "Live close to Phoenix Children's Hospital at Echo Biltmore apartments. Discover comfort and convenience in our prime location.",
      "page_copy": "Echo Biltmore offers the perfect living solution for those needing proximity to Phoenix Children's Hospital. Our apartments are designed for both relaxation and accessibility, ensuring you’re mere minutes away when urgency strikes.\n\nLocated in the heart of Phoenix, Echo Biltmore combines luxury living with practical benefits. Choose from our meticulously crafted one and two-bedroom apartments, each featuring modern touches like stainless steel appliances and controlled access. Our community amenities, including a resort-style pool and a vibrant clubhouse, provide an ideal setting for unwinding after a long day at the hospital. Make Echo Biltmore your peaceful retreat near Phoenix Children's Hospital and experience the ultimate blend of comfort and convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-4167-7389-a855-33f5f99356fb.webp",
      "featured_image_media": {
        "alt_text": "An outdoor swimming pool is the focal point of this courtyard, surrounded by apartment buildings and lounge areas.",
        "public_id": "019d02c8-4167-7389-a855-33f5f99356fb",
        "storage_key": "property/6767906449166424/019d02c8-4167-7389-a855-33f5f99356fb.webp",
        "width": 1518,
        "height": 854
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Echo Biltmore: Close to Phoenix Children's",
      "seo_description": "Stay near Phoenix Children's Hospital at Echo Biltmore. Find luxury apartment living with prime access and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "generator",
      "page_item_url": "apartments-near-steele-indian-school-park-phoenix",
      "search_query": "apartments near Steele Indian School Park Phoenix AZ",
      "category": "Park",
      "h1_title": "Apartments Near Steele Indian School Park",
      "h2_subtitle": "Discover Echo Biltmore apartments near Steele Indian School Park, Phoenix, AZ. Enjoy the perfect blend of nature and luxury.",
      "page_copy": "Echo Biltmore is perfectly positioned close to Steele Indian School Park, making it an ideal choice for those who appreciate the blend of urban living and natural beauty. Just a short distance from this lush green park, our community offers an escape to tranquility right in the heart of Phoenix, AZ.\n\nOur one and two-bedroom apartments provide contemporary interiors with amenities like stainless steel appliances and controlled access. With a resort-style pool, fitness center, and welcoming clubhouse, Echo Biltmore ensures a lifestyle of leisure and relaxation. Whether you're taking a stroll in Steele Indian School Park or lounging by the pool, our apartments offer the perfect base for your lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-4167-7389-a855-33f5f99356fb.webp",
      "featured_image_media": {
        "alt_text": "An outdoor swimming pool is the focal point of this courtyard, surrounded by apartment buildings and lounge areas.",
        "public_id": "019d02c8-4167-7389-a855-33f5f99356fb",
        "storage_key": "property/6767906449166424/019d02c8-4167-7389-a855-33f5f99356fb.webp",
        "width": 1518,
        "height": 854
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Steele Indian School Park",
      "seo_description": "Find Echo Biltmore apartments near Steele Indian School Park in Phoenix, AZ. Enjoy luxurious living close to scenic outdoor spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "generator",
      "page_item_url": "apartments-close-to-encanto-park-camelback-east",
      "search_query": "apartments close to Encanto Park Camelback East Village",
      "category": "Park",
      "h1_title": "Apartments Close to Encanto Park",
      "h2_subtitle": "Experience Echo Biltmore living near Encanto Park in Camelback East Village. Enjoy urban convenience and outdoor leisure.",
      "page_copy": "Located near the picturesque Encanto Park, Echo Biltmore offers exquisite apartments that cater to those who value natural beauty and top-notch urban amenities. Nestled in Camelback East Village, our community combines the best of both worlds, bringing scenic outdoor spaces and vibrant city life within easy reach.\n\nChoose from our luxurious one and two-bedroom floor plans that feature modern comforts like stainless steel appliances and a secure, controlled access environment. Residents enjoy resort-style amenities, including a sparkling pool and a contemporary fitness center. With Encanto Park just a short drive away, Echo Biltmore provides an ideal setting for relaxation and recreation in Phoenix.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-4167-7389-a855-33f5f99356fb.webp",
      "featured_image_media": {
        "alt_text": "An outdoor swimming pool is the focal point of this courtyard, surrounded by apartment buildings and lounge areas.",
        "public_id": "019d02c8-4167-7389-a855-33f5f99356fb",
        "storage_key": "property/6767906449166424/019d02c8-4167-7389-a855-33f5f99356fb.webp",
        "width": 1518,
        "height": 854
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Encanto Park, Camelback East",
      "seo_description": "Discover Echo Biltmore: luxury apartments near Encanto Park in Camelback East Village. Enjoy city convenience and serene park proximity.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "generator",
      "page_item_url": "apartments-near-phoenix-sky-harbor-airport",
      "search_query": "apartments near Phoenix Sky Harbor International Airport",
      "category": "Transit",
      "h1_title": "Apartments Near Phoenix Sky Harbor Airport",
      "h2_subtitle": "Conveniently located near Phoenix Sky Harbor International Airport, Echo Biltmore offers modern living with exceptional accessibility.",
      "page_copy": "Echo Biltmore provides the perfect residence for frequent flyers and travel enthusiasts seeking proximity to Phoenix Sky Harbor International Airport. Nestled in the vibrant heart of Phoenix, our apartments offer unrivaled access to both air travel and the city's bustling energy.\n\nResidents can choose from spacious one and two-bedroom floor plans featuring upscale finishes, including stainless steel appliances and controlled access for peace of mind. With resort-style amenities such as a luxurious pool, a well-equipped fitness center, and a cozy clubhouse, you'll enjoy a blend of comfort and convenience. Echo Biltmore is not just an ideal base for your journeys but also an inviting retreat to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-4167-7389-a855-33f5f99356fb.webp",
      "featured_image_media": {
        "alt_text": "An outdoor swimming pool is the focal point of this courtyard, surrounded by apartment buildings and lounge areas.",
        "public_id": "019d02c8-4167-7389-a855-33f5f99356fb",
        "storage_key": "property/6767906449166424/019d02c8-4167-7389-a855-33f5f99356fb.webp",
        "width": 1518,
        "height": 854
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Live Near Phoenix Sky Harbor Airport",
      "seo_description": "Echo Biltmore offers stylish apartments near Phoenix Sky Harbor International Airport. Enjoy convenient access and premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "generator",
      "page_item_url": "echo-biltmore-near-terminal-3-station-transit",
      "search_query": "Echo Biltmore near Terminal 3 Station transit",
      "category": "Transit",
      "h1_title": "Echo Biltmore Near Terminal 3 Station",
      "h2_subtitle": "Explore the convenience of living at Echo Biltmore, situated close to Terminal 3 Station transit in Phoenix, AZ. Perfect for easy commuting.",
      "page_copy": "Echo Biltmore offers an exceptional living experience for commuters and city explorers, being near Terminal 3 Station transit in Phoenix. Our community provides the perfect blend of accessibility and luxurious comforts, ideal for those who value both convenience and style.\n\nChoose from elegantly designed one and two-bedroom apartments, each fitted with contemporary amenities like stainless steel appliances and controlled access. Enjoy our resort-style facilities including a swimming pool, fitness center, and atmosphere-centric clubhouse, ensuring you lead a lifestyle of ease and relaxation. At Echo Biltmore, you'll appreciate living close to transit options that connect you effortlessly with the rest of Phoenix, making your daily commute a breeze.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-4167-7389-a855-33f5f99356fb.webp",
      "featured_image_media": {
        "alt_text": "An outdoor swimming pool is the focal point of this courtyard, surrounded by apartment buildings and lounge areas.",
        "public_id": "019d02c8-4167-7389-a855-33f5f99356fb",
        "storage_key": "property/6767906449166424/019d02c8-4167-7389-a855-33f5f99356fb.webp",
        "width": 1518,
        "height": 854
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Echo Biltmore at Terminal 3 Transit",
      "seo_description": "Discover Echo Biltmore near Terminal 3 Station transit. Luxury living with easy access to Phoenix's transit system for seamless commuting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "generator",
      "page_item_url": "camelback-east-village-apartments-near-44th-st-washington-station",
      "search_query": "Camelback East Village apartments near 44th St/Washington station",
      "category": "Transit",
      "h1_title": "Camelback East Village Apts Near 44th St Station",
      "h2_subtitle": "Discover Echo Biltmore living in Camelback East Village, close to the 44th St/Washington station for seamless transit access and urban living.",
      "page_copy": "Echo Biltmore offers a unique blend of urban vitality and suburban tranquility in Camelback East Village, conveniently located near the 44th St/Washington station. Our community is perfect for residents who need efficient commute options while enjoying luxurious amenities.\n\nChoose from spacious one and two-bedroom apartments featuring modern conveniences such as stainless steel appliances and controlled access. Our resort-level amenities, including a sparkling pool and fitness center, contribute to a lifestyle of leisure and convenience. With quick access to the 44th St/Washington transit station, Echo Biltmore provides easy connectivity to the broader Phoenix area, making it an ideal living choice for those who love the vibrancy of city life paired with comfortable home retreat.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-4167-7389-a855-33f5f99356fb.webp",
      "featured_image_media": {
        "alt_text": "An outdoor swimming pool is the focal point of this courtyard, surrounded by apartment buildings and lounge areas.",
        "public_id": "019d02c8-4167-7389-a855-33f5f99356fb",
        "storage_key": "property/6767906449166424/019d02c8-4167-7389-a855-33f5f99356fb.webp",
        "width": 1518,
        "height": 854
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Camelback East Apts Near 44th St Station",
      "seo_description": "Explore Echo Biltmore, Camelback East Village apartments near 44th St/Washington station. Enjoy luxury amenities and convenient transit access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166424",
      "source": "generator",
      "page_item_url": "44th-st-station-nearby-apartments-phoenix-az",
      "search_query": "44th St Station nearby apartments Phoenix AZ",
      "category": "Transit",
      "h1_title": "44th St Station Nearby Apartments",
      "h2_subtitle": "Live at Echo Biltmore, offering superb access to the 44th St Station in Phoenix, AZ. Experience premium living in a prime location.",
      "page_copy": "Echo Biltmore stands as an ideal choice for those searching for nearby apartments with excellent accessibility to the 44th St Station in Phoenix, AZ. Situated in the desirable Camelback East Village, our community offers a blend of sophisticated living and connectivity.\n\nResidents enjoy spacious one and two-bedroom floor plans, complete with luxurious finishes like stainless steel appliances and controlled access. Top-tier amenities such as a resort-style pool and a modern fitness center enhance the living experience, providing a perfect balance of relaxation and activity. With the added benefit of being near 44th St Station, Echo Biltmore ensures seamless access to public transit, connecting you effortlessly to the heart of Phoenix and beyond.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166424/019d02c8-4167-7389-a855-33f5f99356fb.webp",
      "featured_image_media": {
        "alt_text": "An outdoor swimming pool is the focal point of this courtyard, surrounded by apartment buildings and lounge areas.",
        "public_id": "019d02c8-4167-7389-a855-33f5f99356fb",
        "storage_key": "property/6767906449166424/019d02c8-4167-7389-a855-33f5f99356fb.webp",
        "width": 1518,
        "height": 854
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near 44th St Station, Phoenix AZ",
      "seo_description": "Find Echo Biltmore, apartments near 44th St Station in Phoenix, AZ. Enjoy luxury areas with easy transit access and premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5294"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18104425006"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-58VN9V4T"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Milburn"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Milburn Homestead"
    },
    {
      "ID": "custom_aim_property_code",
      "type": "STRING",
      "value": "1109ECHO"
    },
    {
      "ID": "custom_anyonehome_chatbot",
      "type": "STRING",
      "value": "<link rel='stylesheet' href='https://www.myshowing.com/css/omnichannel/omnichannel_communication.css'><script src='https://www.myshowing.com/js/omnichannel/omnichannel_communication.js'></script><script text='text/javascript'>window.OmniChannel.init('sdg6to4snmC24rVcpY')</script>"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "40249517126"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/rkwn1l8zpd2"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "BR573712000"
    },
    {
      "ID": "custom_anyonehome_scheduler_url",
      "type": "STRING",
      "value": "https://www.myshowing.com/AMC_LLC/Echo_Biltmore_Apartments/scheduletourwidget/k3E1Ejxkjm8hpQC5nD/"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlhQU1JMZ0NKVE1zZ3hwYktaSjZsOEE9PSIsInZhbHVlIjoiVVlhUndoNGF2clVUclVxSlRFTEhlQT09IiwibWFjIjoiNzZiMTkxNzdlMDgxNGZjZTJkM2FjNzJlZTdiZGNiYmUxMWU0MGMzYmUzOTZjZDIyYzc3ZDg1NmRmOWU1ZTZjMiJ9"
    }
  ],
  "custom_qb_id": "5294",
  "custom_repli_id": "18104425006",
  "custom_google_gtm_id": "GTM-58VN9V4T",
  "custom_rollout_phase": "Milburn",
  "custom_vibesites_theme": "Milburn Homestead",
  "custom_aim_property_code": "1109ECHO",
  "custom_anyonehome_chatbot": "<link rel='stylesheet' href='https://www.myshowing.com/css/omnichannel/omnichannel_communication.css'><script src='https://www.myshowing.com/js/omnichannel/omnichannel_communication.js'></script><script text='text/javascript'>window.OmniChannel.init('sdg6to4snmC24rVcpY')</script>",
  "custom_hubspot_company_id": "40249517126",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/rkwn1l8zpd2",
  "custom_broker_license_number": "BR573712000",
  "custom_anyonehome_scheduler_url": "https://www.myshowing.com/AMC_LLC/Echo_Biltmore_Apartments/scheduletourwidget/k3E1Ejxkjm8hpQC5nD/",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlhQU1JMZ0NKVE1zZ3hwYktaSjZsOEE9PSIsInZhbHVlIjoiVVlhUndoNGF2clVUclVxSlRFTEhlQT09IiwibWFjIjoiNzZiMTkxNzdlMDgxNGZjZTJkM2FjNzJlZTdiZGNiYmUxMWU0MGMzYmUzOTZjZDIyYzc3ZDg1NmRmOWU1ZTZjMiJ9",
  "custom_audioeye_site_id": "0bead884-d20e-4625-9316-e099e8ec328b",
  "custom_audioeye_site_hash": "4e7aca35a1b80fe9fc2571a5ceb5b4aa"
};

export const generatedAt = '2026-09-14T13:29:56.174Z';
